import { DRAWER_TOOLSET_EXPANDED, BEAMS_AND_POSTS_TOOL } from "../../redux_store/appState";
import * as APP from "../../redux_store/appState";
import * as COMMON from "../../components/Common";
import { GetHTMLColour, toNumber } from "../../components/Common";

import { BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";
import tinycolor from "tinycolor2";
import paper from "paper";
import { GetShapeUpdateString, GetSpecAllAreas } from "./PaperFunctionHelper";
import _ from "lodash";
import React from "react";
import { EngineerDeckv2 } from "../../redux_store/jobState_Validation";
import { API_BASE } from "../../AppConfig";
import { updateAreaSpecification } from "../../redux_store/jobState";
import { updateLayout2D } from "../../redux_store/appStateHelper";
import { FormatSVGForExtendBeam } from "../context_options/SpecExtendBeams";
import WarningIcon from "@material-ui/icons/Warning";

// const paper = paper;
var _this = {};

export const WarningIcon_Orange = <WarningIcon style={{ color: "orange", width: "20px", height: "12px" }} />;

// const ROOF_SHEETING = "ROOF_SHEETING";
// const GUTTERS_AND_DOWNPIPES = "GUTTERS_AND_DOWNPIPES";
// const ATTACHMENT = "ATTACHMENT";
// const BEAMS_AND_POSTS = "BEAMS_AND_POSTS";

export const LoadSVGFromData = (svg_data, svg) => {
    if (window.last_svg_load_attempt === svg) return; //already try/loaded

    let zoom_all = false;
    let last_was_layout = window.last_svg_load_attempt.includes("layout.svg");
    if (last_was_layout) zoom_all = true;

    window.last_svg_load_attempt = svg;

    let url_base = API_BASE() + "svg/" + "XYZ/" + svg;
    if (svg_data) {
        url_base = URL.createObjectURL(new Blob([svg_data], { type: "image/svg+xml" }));
    }

    paper.project.importSVG(url_base, {
        onLoad: (new_item, svg_raw) => {
            if (!new_item) return;
            new_item.svg_filename = url_base;
            new_item.scale(1);
            if (paper.project.activeLayer.children.length > 1) {
                paper.project.activeLayer.removeChildren(0, paper.project.activeLayer.children.length - 1);
            }
            window.svg = new_item;
            FormatSVGToJob();
            UpdateAllSVGMaterials();
            GetMetaData();
            if (zoom_all) zoomAll();
            paper.view.draw();

            UpdateJobFromSVG();
        },
        onError: (message, status) => {
            ClearAll();
        },
    });
};

export function ClearAll() {
    if (paper.project) {
        paper.project.activeLayer.removeChildren();
        paper.project.activeLayer.clear();
        paper.view.draw();
    }
}

export function zoomIn() {
    let zoom = paper.view.zoom * 1.1;
    if (zoom > 7) zoom = 7;
    paper.view.zoom = zoom;
}
export function zoomOut() {
    let zoom = paper.view.zoom / 1.1;
    if (zoom < 0.03) zoom = 0.03;
    paper.view.zoom = zoom;
}

export function zoomAll(sidebar_adjustment_factor = null) {
    if (paper.project.activeLayer.children.length === 0) return;

    if (sidebar_adjustment_factor === null) {
        sidebar_adjustment_factor = 300;
        const TOOL_DRAWER_HIDE = window?.app?.designer?.[APP.TOOL_DRAWER_HIDE];
        const TOOL_DRAWER_WIDTH = window?.app?.designer?.[APP.TOOL_DRAWER_WIDTH];
        sidebar_adjustment_factor = TOOL_DRAWER_WIDTH - 90;
        if (TOOL_DRAWER_HIDE) sidebar_adjustment_factor = 0;
    }

    let topbar_adjustment_factor = 60;

    let bottom_adjustment_factor = 0;

    const THREED_MODE = window?.app?.designer?.[APP.THREED_MODE];
    const THREED_MINI_MODE = window?.app?.designer?.[APP.THREED_MINI_MODE];
    const THREED_MINI_HEIGHT = window?.app?.designer?.[APP.THREED_MINI_HEIGHT];
    const THREED_MINI_WIDTH = window?.app?.designer?.[APP.THREED_MINI_WIDTH];

    if (THREED_MODE && THREED_MINI_MODE) {
        if (THREED_MINI_MODE === true) topbar_adjustment_factor = THREED_MINI_HEIGHT;
        else sidebar_adjustment_factor = THREED_MINI_WIDTH - 90;
    }

    var screen_size = {
        width: paper.view.viewSize.width - sidebar_adjustment_factor,
        height: paper.view.viewSize.height - bottom_adjustment_factor - topbar_adjustment_factor,
    };
    var screen_ratio = screen_size.width / screen_size.height;

    var objects_size = paper.project.activeLayer.bounds.size;
    var objects_ratio = objects_size.width / objects_size.height;

    if (isNaN(objects_ratio)) return;
    var zoom = 1;
    if (objects_ratio > screen_ratio) {
        //scale by width
        zoom = screen_size.width / objects_size.width;
    } else {
        //scale by height
        zoom = screen_size.height / objects_size.height;
    }
    //
    paper.view.zoom = zoom * 0.8;
    let center = paper.project.activeLayer.bounds.center;
    let adjusment = new paper.Point(
        sidebar_adjustment_factor / paper.view.zoom / 2,
        (-topbar_adjustment_factor + bottom_adjustment_factor) / paper.view.zoom / 2
    );

    paper.view.center = center.add(adjusment);
}

export function loadMap() {
    var map_url = "images/20190302_WGS84_S_Mercator_138_57260_-34_93000_138_57356_-34_92956_21.jpg";
    var map_geodata_url = map_url.replace(".jpg", ".jgw");

    fetch(map_geodata_url)
        .then((res) => {
            return res.text();
        }) // Gets the response and returns it as a blob
        .then((text) => {
            // By lines
            var lines = text.split("\n");
            var x_scale = 1;
            var y_scale = 1;
            for (var line = 0; line < 4; line++) {
                //
                if (line === 0) x_scale = Number(lines[line]);
                if (line === 3) y_scale = Number(lines[line]);
            }
            var raster = new paper.Raster(map_url);
            raster.onLoad = function () {
                raster.name = "imported_map";
                raster.sendToBack();
                raster.width = 87730 / paper.view.scale;
                raster.height = 48880 / paper.view.scale;
                raster.opacity = 0.5;
                zoomAll();
            };
        });
    paper.view.draw();
}

export function loadGoogleMap(address, zoom = 21) {
    let scale = 2;
    // let zoom = 21;
    let zoom_scale_base_20 = 1.12849722 / 0.94;
    let zoom_scale = zoom_scale_base_20 / 2;
    if (zoom === 20) zoom_scale = zoom_scale_base_20;
    if (zoom === 19) zoom_scale = zoom_scale_base_20 * 2;
    if (zoom <= 18) {
        zoom = 18;
        zoom_scale = zoom_scale_base_20 * 4;
    }

    // let metersPerPx = 156543.03392 * Math.cos(138.476657 * Math.PI / 180) / Math.pow(2, zoom);
    //
    //
    // zoom_scale = -metersPerPx*10;

    var map_url =
        "https://maps.googleapis.com/maps/api/staticmap?center=" +
        address +
        "&zoom=" +
        zoom +
        "&scale=" +
        scale +
        "&size=1800x1800&maptype=hybrid&key=AIzaSyDusbQSuHd8yi5wBk8x4skpqjH4ttqBc2w";

    // var map_geodata_url = map_url.replace(".jpg", ".jgw");

    var item = paper.project.getItem({
        name: "imported_map_google",
    });

    if (item) item.remove();

    var raster = new paper.Raster(map_url);
    raster.onLoad = function () {
        raster.name = "imported_map_google";
        raster.sendToBack();
        raster.width = raster.width * scale * zoom_scale;
        raster.height = raster.height * scale * zoom_scale;
        // raster.width = 1128.497220/paper.view.scale;
        // raster.height = 1128.497220/paper.view.scale;
        raster.opacity = 0.5;
        zoomAll();
    };

    // fetch(map_geodata_url)
    // .then(res => { return res.text()}) // Gets the response and returns it as a blob
    // .then(text => {
    //         // By lines
    //     var lines = text.split('\n');
    //     var x_scale = 1;
    //     var y_scale = 1;
    //     for (var line = 0; line < 4; line++) {
    //         //
    //         if (line === 0) x_scale = Number(lines[line]);
    //         if (line === 3) y_scale = Number(lines[line]);
    //     }
    //   });
    paper.view.draw();
}

export function UpdateSVGsIfRequired(svgs) {
    for (var key in svgs) {
        if (paper.project !== null && svgs.hasOwnProperty(key) && svgs[key] !== null && svgs[key] !== "") {
            let svg_url = svgs[key];

            var item = paper.project.getItem({
                name: key,
            });

            if (item /* exists_in_paper*/) {
                // check if already added, and update existing
                // item.visible = false;

                paper.project.importSVG(svg_url, {
                    onLoad: (new_item, svg_raw) => {
                        new_item.name = key;
                        new_item.scale(1);
                        item.remove();
                        item.name = null;
                        this.zoomAll();
                        window.svg = new_item;
                        FormatSVGToJob();
                        UpdateRoofSheets();
                        GetMetaData();
                        paper.view.draw();
                    },
                });
            } else {
                paper.project.importSVG(svg_url, {
                    onLoad: (new_item, svg_raw) => {
                        new_item.name = key;
                        new_item.scale(1);

                        window.svg = new_item;
                        FormatSVGToJob();
                        UpdateRoofSheets();
                        GetMetaData();
                        this.zoomAll();
                        paper.view.draw();
                    },
                });
            }
        }
    }
}

export function generateRoof() {
    var house_plan = paper.project.importSVG("images/roof_native.svg", {
        onLoad: (item, svg_raw) => {
            // item.scale(0.41, 0.41);
            item.scale(1 / paper.view.scale);
            item.rotate(-3.555);
            item.position = new paper.Point(-10, -150);
            item.bringToFront();
            item.on("mousedrag", function (e) {
                item.position = item.position.add(e.delta);
            });
        },
    });
    // house_plan.rotate(45);
}

// export function ClearAll() {

//     paper.project.activeLayer.clear();
//     var from = new paper.Point(0, 0);
//     var middle = new paper.Point(0, 0);
//     var to = new paper.Point(0, 0);
//     paper.project.activeLayer.rubberband = new paper.Path(from, middle, to);
//     var rubberband = paper.project.activeLayer.rubberband;
//     rubberband.name = "rubberband";
//     rubberband.strokeColor = 'black';
//     rubberband.dashArray = [3, 3];
//     rubberband.visible = false;
//     paper.project.activeLayer.rubberband_label = new paper.PointText(new paper.Point(200, 50));
//     var rubberband_label = paper.project.activeLayer.rubberband_label;
//     rubberband_label.name = "rubberband label";
//     rubberband_label.justification = 'center';
//     rubberband_label.justification = 'center';
//     rubberband_label.fillColor = 'black';
//     rubberband_label.content = '2000mm';
//     rubberband.visible = false;
//     paper.view.draw();
// }

export function Load_FlatDesign() {
    paper.project.importSVG("images/flat.svg", {
        onLoad: (item, svg_raw) => {
            item.scale(1);
            this.zoomAll();
        },
    });
}

export function loadToggleSVG(file_name) {
    var item = paper.project.getItem({
        name: file_name,
    });

    if (item !== null) {
        item.visible = !item.visible;
    } else {
        paper.project.importSVG("images/" + file_name + ".svg", {
            onLoad: (item, svg_raw) => {
                item.name = file_name;
                item.scale(1);
                this.zoomAll();
            },
        });
    }
}

export function ForceUpdate() {
    function ExecuteUpdate() {
        if (paper.project) {
            // paper.project._needsUpdate = true;
            // paper.project.view.update();
            // paper.view.fire('resize', paper.view);
            window.dispatchEvent(new Event("resize"));
        }
    }

    if (paper.project) {
        ExecuteUpdate();
        setTimeout(function () {
            ExecuteUpdate();
            setTimeout(function () {
                ExecuteUpdate();
            }, 1000);
        }, 100);
    } else {
        setTimeout(function () {
            ExecuteUpdate();
            setTimeout(function () {
                ExecuteUpdate();
            }, 2000);
        }, 100);
    }
}

export function InitialisePaper(id) {
    // return;
    // Get a reference to the canvas object
    var canvas = document.getElementById(id);
    // Create an empty project and a view for the canvas:
    paper.setup(canvas);
    paper.project.options.handleSize = 6;
    paper.settings.hitTolerance = 6;
    paper.view.zoom = 1;
    paper.view.scale = 25;
    paper.view.scale = 25;
    paper.view.viewSize = new paper.Size(1920, 1200);
    window.paper = paper;
    window.paper_canvas = canvas;

    var segment_to_drag = false;
    var segment_to_drag_was_dragged = false;

    paper.view.onMouseUp = (e) => {
        //
        // // this.wasDragged = false;
        // alert(e);

        var hitResult = paper.project.activeLayer.hitTest(e.point, hitOptions); // isPointInPath

        if (!window.dragging && hitResult && hitResult.item) {
            if (hitResult.item.is_roofsheet)
                hitResult.item.is_skylight = hitResult.item.is_skylight ? !hitResult.item.is_skylight : true;
            UpdateRoofSheets();
            // if (hitResult.item.fillColor_o === null) hitResult.item.fillColor_o = hitResult.item.fillColor;

            // if (hitResult.item.is_skylight)
            // {
            //     hitResult.item.fillColor = new paper.Color(1, 1, 1, 1);
            // }
            // else
            // {
            //     if (hitResult.item.fillColor_o !== null) hitResult.item.fillColor = hitResult.item.fillColor_o;
            // }
            // alert(name);
            // setTimeout(function(){ alert(name); }, 200);
        }
        window.dragging = false;
    };
    paper.view.onMouseDown = (e) => {
        // this.wasDragged = false;
        //

        window.dragging = false;
        _this.downPoint = e.point;
        _this.downPointScreen = new paper.Point(e.event.x, e.event.y);
        _this.downButton = e.event.button;

        // var selected_items = paper.project.getItems({ selected: true });
        // segment_to_drag = false;
        // segment_to_drag_was_dragged = false;
        // if (_this.downButton === 0 && selected_items.length > 0) {
        //     var hitResult = paper.project.activeLayer.hitTest(e.point, { match: (function (o) { return ((o.type === "handle-in" || o.type === "handle-out") && o.item.name !== "rubberband") }), curves: true, handles: true, tolerance: paper.settings.hitTolerance / paper.view.zoom });
        //
        //     if (hitResult) segment_to_drag = hitResult.segment;
        // }
        // var hitResult = paper.project.activeLayer.hitTest(e.point, { match: (function (o) { return ((o.type === "handle-in" || o.type === "handle-out") && o.item.name !== "rubberband") }), curves: true, handles: true, tolerance: paper.settings.hitTolerance / paper.view.zoom });

        //
        // if (selected_items && selected_items[2])
    };

    var bg_pos1 = new paper.Point(-50, -50);
    var bg_pos2 = new paper.Point(-50, -50);
    var orig_bg_zoom1 = 100;
    var orig_zoom = 1;
    var last_rounded = 100;

    function offset_grid(offset = new paper.Point(-0, -0)) {
        var change_ratio = paper.view.zoom / orig_zoom;

        // var change_ratio = paper.view.zoom / orig_zoom;
        var rounded = orig_bg_zoom1 * change_ratio;
        var rounded_sm = rounded / 5;
        document.getElementById("qqCanvas").style.backgroundSize =
            rounded +
            "px " +
            rounded +
            "px, " +
            rounded +
            "px " +
            rounded +
            "px, " +
            rounded_sm +
            "px " +
            rounded_sm +
            "px, " +
            rounded_sm +
            "px " +
            rounded_sm +
            "px";

        if (rounded !== last_rounded) {
            offset = offset.add(new paper.Point(-(rounded - last_rounded) / 2, -(rounded - last_rounded) / 2));
        }
        // bg_pos1 = bg_pos1.subtract(new paper.Point(-(rounded-last_rounded)/2, -(rounded-last_rounded)/2));
        // // bg_pos1 = bg_pos1.subtract(rounded);
        // bg_pos1 = bg_pos1.subtract(offset);
        // bg_pos2 = bg_pos2.subtract(offset);
        if (offset) {
            offset.x = offset.x * change_ratio;
            offset.y = offset.y * change_ratio;
            bg_pos1 = bg_pos1.subtract(offset);
            bg_pos2 = bg_pos2.subtract(offset);
            document.getElementById("qqCanvas").style.backgroundPosition =
                bg_pos1.x +
                "px " +
                bg_pos1.y +
                "px, " +
                bg_pos1.x +
                "px " +
                bg_pos1.y +
                "px, " +
                bg_pos2.x +
                "px " +
                bg_pos2.y +
                "px, " +
                bg_pos2.x +
                "px " +
                bg_pos2.y +
                "px";
        }
        last_rounded = rounded;
    }

    var qqCanvas = document.getElementById("qqCanvas");
    if (qqCanvas)
        qqCanvas.addEventListener("wheel", function (e) {
            var delta = e.deltaY;
            var zoom = paper.view.zoom * (1 - delta / 4500);

            // zoom = zoom * (1 + delta / 5500);

            if (zoom > 7) zoom = 7;
            if (zoom < 0.03) zoom = 0.03;
            paper.view.zoom = zoom;

            offset_grid();

            e.preventDefault();
            e.stopPropagation();
        });
    if (qqCanvas)
        qqCanvas.addEventListener("contextmenu", function (e) {
            e.preventDefault();
        });

    // return;

    paper.view.onMouseDrag = function (e) {
        //     // draw rubber band
        //     rubberband.visible = true;
        //     rubberband.bringToFront();
        //     rubberband.segments[0].point = this.lastPointAdded;
        //     rubberband.segments[1].point = e.point;
        // }

        // var distance_dragged = _this.downPoint?_this.downPoint.subtract(e.point):0;
        var distance_dragged = _this.downPoint ? _this.downPoint.getDistance(e.point) : 0;
        var distance_screen_dragged = _this.downPointScreen.getDistance(new paper.Point(e.event.x, e.event.y));
        // var offset = _this.downPoint.subtract(e.point);

        if (_this.downButton === 0 && segment_to_drag && (distance_dragged > 10 || segment_to_drag_was_dragged)) {
            segment_to_drag.point = segment_to_drag.point.add(e.delta);
            segment_to_drag_was_dragged = true;
        } else if (distance_screen_dragged > 20 && !window.dragging) {
            window.dragging = true;
        } else if ((_this.downButton === 0 || _this.downButton === 1 || _this.downButton === 2) && window.dragging) {
            _this.dragging = true;
            var offset = _this.downPoint.subtract(e.point);
            paper.view.center = paper.view.center.add(offset);
            offset_grid(offset);

            // document.getElementById("qqCanvas").style.backgroundPosition = "-2px -2px, -2px -2px, -1px -1px, -1px -1px";

            // var bg_pos = document.getElementById("qqCanvas").style.backgroundPosition;
            // if (bg_pos === "") bg_pos = "-2px -2px, -2px -2px, -1px -1px, -1px -1px";
            // var offsets = bg_pos.split(',');
            // var offset_1_X = offsets[0].split(' ')[0].replace("px","").trim();
            // var offset_1_Y = offsets[0].split(' ')[1].replace("px","").trim();
            // var offset_2_X = offsets[2].trim().split(' ')[0].replace("px","").trim();
            // var offset_2_Y = offsets[2].trim().split(' ')[1].replace("px","").trim();
        }
    };

    // The Path.Line constructor takes 2 points, defining the start and end of the line.
    var from = new paper.Point(0, 0);
    var middle = new paper.Point(0, 0);
    var to = new paper.Point(0, 0);
    paper.project.activeLayer.rubberband = new paper.Path(from, middle, to);
    var rubberband = paper.project.activeLayer.rubberband;
    rubberband.name = "rubberband";
    rubberband.strokeColor = "black";
    rubberband.dashArray = [3, 3];
    rubberband.visible = false;
    paper.project.activeLayer.rubberband_label = new paper.PointText(new paper.Point(200, 50));
    var rubberband_label = paper.project.activeLayer.rubberband_label;
    rubberband_label.name = "rubberband label";
    rubberband_label.justification = "center";
    rubberband_label.justification = "center";
    rubberband_label.fillColor = "black";
    rubberband_label.content = "2000mm";
    rubberband.visible = false;
    var rubberband_to_point;

    var offset;
    var offsetSpeed;
    var offset_run = false;
    var offset_running = false;
    var offset_direction = "top";

    paper.view.onMouseMove = function (e) {
        rubberband_label.visible = rubberband.visible;
        if (_this.adding_points_to_this_path && rubberband.visible) {
            _this.last_onMouseMove_event_data = e;

            //snap e.point to vector angle
            var from_point = _this.rubberband_from;
            rubberband_to_point = e.point;
            if (from_point) {
                var vector_mouse = rubberband_to_point.subtract(from_point);
                var new_vector = new paper.Point(0, 0);
                var vector_last_line = new paper.Point(0, 0);

                if (_this.adding_points_to_this_path && _this.adding_points_to_this_path.segments.length >= 2) {
                    let num_segments = _this.adding_points_to_this_path.segments.length;
                    vector_last_line = _this.adding_points_to_this_path.segments[num_segments - 1].point.subtract(
                        _this.adding_points_to_this_path.segments[num_segments - 2].point
                    );

                    //    vector_mouse = vector_mouse.subtract(vector_last_line);
                }

                //
                new_vector.length = vector_mouse.length;
                var angle_relative_to_last_line = vector_mouse.angle - vector_last_line.angle;
                var mod = Math.abs(angle_relative_to_last_line % 45);

                var snap_tolerance = 3;
                var snapped = false;
                if (!e.modifiers.control) {
                    if (
                        (mod < snap_tolerance && mod > -snap_tolerance) ||
                        (mod > 45 - snap_tolerance && mod < 45 + snap_tolerance)
                    ) {
                        var angle = Math.round(angle_relative_to_last_line / 45) * 45 + vector_last_line.angle;

                        new_vector.angle = angle;
                        rubberband_to_point = from_point.add(new_vector);
                        snapped = true;
                    }
                }

                //    if (vector_mouse.angle > 87.5 && vector_mouse.angle < 92.5) {
                //        //snap to 90
                //        new_vector.angle = 90;
                //        rubberband_to_point = from_point.add(new_vector);
                //    }
                //    if (vector_mouse.angle > 177.5 && vector_mouse.angle < 182.5) {
                //        //snap to 90
                //        new_vector.angle = 180;
                //        rubberband_to_point = from_point.add(new_vector);
                //    }
                //    if (vector_mouse.angle > -177.5 && vector_mouse.angle < -182.5) {
                //        //snap to 90
                //        new_vector.angle = 180;
                //        rubberband_to_point = from_point.add(new_vector);
                //    }
                //    if (vector_mouse.angle > -177.5 && vector_mouse.angle < -182.5) {
                //        //snap to 90
                //        new_vector.angle = 180;
                //        rubberband_to_point = from_point.add(new_vector);
                //    }
            }

            new paper.Point(0, 0);

            //
            // draw rubber band
            rubberband.bringToFront();
            rubberband.segments[0].point = _this.rubberband_from ? _this.rubberband_from : rubberband_to_point;
            rubberband.segments[1].point = rubberband_to_point;
            rubberband.segments[2].point = _this.rubberband_end ? _this.rubberband_end : rubberband_to_point;
            var vector1 = rubberband_to_point.subtract(rubberband.segments[0].point);

            var actual_angle_relative_to_last_line = vector1.angle - vector_last_line.angle;

            rubberband_label.point = e.point.add(new paper.Point(100 / paper.view.zoom, 10));
            rubberband_label.content =
                Math.round(vector1.length * paper.view.scale) +
                "mm @" +
                actual_angle_relative_to_last_line.toFixed(2) +
                " degs\n" +
                (snapped ? " *press ctrl to unsnap*" : "");
            rubberband_label.fontSize = 14 / paper.view.zoom;

            var scroll_tolerance = 100;
            offsetSpeed = 2 / paper.view.zoom;
            if (e.event.y < scroll_tolerance) {
                offset_direction = "top";
                offset_run = true;
                if (e.event.x < scroll_tolerance * 2) {
                    offset_direction = "top-left";
                } else if (e.event.x > paper.view.viewSize.width - scroll_tolerance * 2) {
                    offset_direction = "top-right";
                }

                if (e.event.y < (scroll_tolerance * 2) / 3) offsetSpeed = offsetSpeed * 2;
                if (e.event.y < scroll_tolerance / 3) offsetSpeed = offsetSpeed * 2;
                if (e.event.y < scroll_tolerance / 10) offsetSpeed = offsetSpeed * 2;
            } else if (e.event.y > paper.view.viewSize.height - scroll_tolerance) {
                offset_direction = "bottom";
                offset_run = true;
                if (e.event.x < scroll_tolerance * 2) {
                    offset_direction = "bottom-left";
                } else if (e.event.x > paper.view.viewSize.width - scroll_tolerance * 2) {
                    offset_direction = "bottom-right";
                }
                if (e.event.y > paper.view.viewSize.height - (scroll_tolerance * 2) / 3) offsetSpeed = offsetSpeed * 2;
                if (e.event.y > paper.view.viewSize.height - scroll_tolerance / 3) offsetSpeed = offsetSpeed * 2;
                if (e.event.y > paper.view.viewSize.height - scroll_tolerance / 10) offsetSpeed = offsetSpeed * 2;
            } else if (e.event.x < scroll_tolerance) {
                offset_direction = "left";
                offset_run = true;
                if (e.event.x < (scroll_tolerance * 2) / 3) offsetSpeed = offsetSpeed * 2;
                if (e.event.x < scroll_tolerance / 3) offsetSpeed = offsetSpeed * 2;
                if (e.event.x < scroll_tolerance / 10) offsetSpeed = offsetSpeed * 2;
            } else if (e.event.x > paper.view.viewSize.width - scroll_tolerance) {
                offset_direction = "right";
                offset_run = true;
                if (e.event.x > paper.view.viewSize.width - (scroll_tolerance * 2) / 3) offsetSpeed = offsetSpeed * 2;
                if (e.event.x > paper.view.viewSize.width - scroll_tolerance / 3) offsetSpeed = offsetSpeed * 2;
                if (e.event.x > paper.view.viewSize.width - scroll_tolerance / 10) offsetSpeed = offsetSpeed * 2;
            } else {
                offset_run = false;
            }

            if (offset_run && !offset_running) {
                let offset_up = () => {
                    offset = new paper.Point(0, -offsetSpeed);
                    if (offset_direction === "top-left") offset = new paper.Point(-offsetSpeed, -offsetSpeed);
                    if (offset_direction === "top-right") offset = new paper.Point(offsetSpeed, -offsetSpeed);
                    if (offset_direction === "bottom") offset = new paper.Point(0, offsetSpeed);
                    if (offset_direction === "bottom-left") offset = new paper.Point(-offsetSpeed, offsetSpeed);
                    if (offset_direction === "bottom-right") offset = new paper.Point(offsetSpeed, offsetSpeed);
                    if (offset_direction === "left") offset = new paper.Point(-offsetSpeed, 0);
                    if (offset_direction === "right") offset = new paper.Point(offsetSpeed, 0);
                    paper.view.center = paper.view.center.add(offset);

                    // offset rubberband
                    rubberband.segments[1].point = rubberband.segments[1].point.add(offset);
                    offset_grid(offset);
                    paper.view.draw();

                    if (offset_run)
                        setTimeout(function () {
                            offset_up();
                        }, 20);
                    else offset_running = false;
                };
                offset_running = true;
                offset_up();
            }
            // else if (!offset_run) {

            // }

            // }
            // offset = new paper.Point(0, 5 / paper.view.zoom);
            // paper.view.center = paper.view.center.add(offset);
            // }
            // else if(e.event.x < 70) {
            //     offset = new paper.Point(-5 / paper.view.zoom, 0);
            //     paper.view.center = paper.view.center.add(offset);
            // }
            // else if(e.event.x > (paper.view.viewSize.width - 70)) {
            //     offset = new paper.Point(5 / paper.view.zoom, 0);
            //     paper.view.center = paper.view.center.add(offset);
            // }
            // }
        }
    };

    // paper.view.onMouseUp = function (e) {
    //     // draggin functions

    //     if (segment_to_drag && segment_to_drag_was_dragged) {
    //         segment_to_drag = false;
    //         segment_to_drag_was_dragged = false;
    //         return;
    //     }
    //     segment_to_drag = false;

    //     if (_this.dragging) {
    //         _this.dragging = false;

    //         var screen_distance = _this.downPointScreen.getDistance(new paper.Point(e.event.x, e.event.y));
    //         //

    //         if (e.event.button === 2 && screen_distance < 20) {
    //             if (_this.adding_points_to_this_path) {
    //                 _this.adding_points_to_this_path = null;
    //                 rubberband.visible = false;
    //                 rubberband.sendToBack();
    //             }
    //             else {
    //                 paper.project.deselectAll();
    //             }
    //         }
    //     }
    //     else {
    //         this.dragging = false;
    //         if (e.event.button === 0) {

    //             var selected_items = paper.project.getItems({ selected: true });

    //             if (_this.adding_points_to_this_path) {
    //                 var new_point = new paper.Point(e.point.x, e.point.y);
    //                 if (rubberband_to_point) new_point = rubberband_to_point;
    //                 _this.adding_points_to_this_path.fullySelected = false;
    //                 _this.adding_points_to_this_path.selected = true;
    //
    //                 if (_this.adding_points_to_this_path_inserting_after_index !== null && _this.adding_points_to_this_path_inserting_after_index < _this.adding_points_to_this_path.segments.length) {

    //
    //                     let new_segment = _this.adding_points_to_this_path.insert(_this.adding_points_to_this_path_inserting_after_index + 1, new_point);
    //                     new_segment.selected = true;
    //                     _this.adding_points_to_this_path_inserting_after_index++;
    //                     _this.rubberband_from = new_point;
    //                 }
    //                 else {
    //

    //                     //check for closing shape
    //                     var hitResult = paper.project.activeLayer.hitTest(new_point, { match: (function (o) { return o.type !== "pixel" && o.item.name !== "rubberband" }), handles: true, tolerance: paper.settings.hitTolerance*2 / paper.view.zoom });

    //
    //                     if (hitResult && hitResult.item === _this.adding_points_to_this_path && hitResult.segment.index === 0) {
    //                         // close shape
    //                         _this.adding_points_to_this_path.closed = true;
    //                         _this.adding_points_to_this_path_inserting_after_index = _this.adding_points_to_this_path.segments.length;
    //                         _this.rubberband_from = _this.adding_points_to_this_path.lastSegment.point;
    //                         _this.rubberband_end = _this.adding_points_to_this_path.firstSegment.point;
    //                         alert("closing shape");
    //                     }
    //                     else {

    //                         let new_segment = _this.adding_points_to_this_path.add(new_point);
    //                         new_segment.selected = true;
    //                         _this.rubberband_from = new_point;
    //                         if (_this.adding_points_to_this_path.closed) {
    //                             _this.rubberband_end = _this.adding_points_to_this_path.firstSegment.point;
    //                         }
    //                         else _this.rubberband_end = new_point;
    //                     }

    //                 }
    //                 _this.adding_points_to_this_path.bringToFront();
    //                 //
    //             }
    //             else if (!_this.adding_points_to_this_path && selected_items.length > 0) {
    //                 // check to see if handle clicked
    //                 // this.handleSelected = null;
    //                 // Do a hit test on selected paths for handles:
    //                 var hitResult = paper.project.activeLayer.hitTest(e.point, { match: (function (o) { return (o.type === "handle-in" || o.type === "handle-out") }), curves: true, handles: true, tolerance: paper.settings.hitTolerance / paper.view.zoom });
    //
    //                 if (hitResult) {
    //
    //                     // if (hitResult.type === 'handle-in') {
    //                     //     this.handleSelected = hitResult.segment.handleIn;
    //                     // } else {
    //                     //     this.handleSelected = hitResult.segment.handleOut;
    //                     // };
    //                     //
    //                     let segment = null;
    //                     if (hitResult.type === "curve") {
    //                         segment = hitResult.location._segment1;
    //                     }
    //                     else segment = hitResult.segment;

    //                     hitResult.item.fullySelected = false;
    //                     hitResult.item.selected = true;
    //                     segment.selected = true;

    //                     _this.adding_points_to_this_path = hitResult.item;
    //                     _this.adding_points_to_this_path_inserting_after_index = segment.index;
    //                     _this.insert = hitResult.item;
    //                     _this.rubberband_from = segment.point;
    //                     if (hitResult.item.segments.length > segment.index + 1) _this.rubberband_end = hitResult.item.segments[segment.index + 1].point;
    //                     else _this.rubberband_end = null;
    //                     rubberband.visible = true;
    //                 }
    //                 else {
    //                     paper.project.deselectAll();
    //                 }

    //             }
    //             else if (!_this.adding_points_to_this_path) {
    //                 // );
    //                 let hits = paper.project.activeLayer.hitTestAll(e.point);
    //                 if (hits.length > 0 && (!hits[0].item.name || !hits[0].item.name.includes("imported_map"))) {
    //                     if (hits[0].item.fullySelected) return;
    //                     paper.project.deselectAll();
    //                     hits[0].item.selected = true;
    //                     // this.lastPointAdded = hits[0].item.segments[hits[0].item.segments.length-1].point;
    //                     // this.adding_points_to_this_path = hits[0].item;
    //                 }
    //                 else {
    //                     if (paper.project.getItems({ selected: true }).length > 0) {
    //                         paper.project.deselectAll();
    //                     }
    //                     else {
    //                         // begin adding points to new path?
    //                         paper.project.deselectAll();
    //                         var new_path = new paper.Path();
    //                         new_path.strokeColor = 'red';
    //                         new_path.strokeWidth = 4;
    //                         new_path.strokeCap = 'round';
    //                         new_path.strokeJoin = 'round';
    //                         new_path.selected = true;
    //                         var point = new paper.Point(e.point.x, e.point.y);
    //                         new_path.add(point);
    //                         _this.rubberband_from = point;
    //                         _this.rubberband_end = point;
    //                         rubberband.visible = true;
    //                         _this.adding_points_to_this_path = new_path;
    //                         new_path.on('mousedrag', function (e) {
    //
    //                             // new_path.position = new_path.position.add(e.delta);
    //                         });
    //
    //
    //                     }

    //                 }
    //             };
    //         };

    //         if (e.event.button === 2) {
    //             if (_this.adding_points_to_this_path) {
    //                 _this.adding_points_to_this_path.fullySelected = false;
    //                 _this.adding_points_to_this_path = null;
    //                 rubberband.visible = false;
    //                 _this.lastPointAdded = null;
    //             }
    //             else {
    //                 paper.project.deselectAll();
    //             }
    //         }
    //     }

    // }

    // paper.view.onKeyDown = function (e) {
    //
    //     var offset;
    //     if (e.key === "up") {
    //         offset = new paper.Point(0, -15 / paper.view.zoom);
    //         paper.view.center = paper.view.center.add(offset);
    //     }
    //     if (e.key === "down") {
    //         offset = new paper.Point(0, 15 / paper.view.zoom);
    //         paper.view.center = paper.view.center.add(offset);
    //     }
    //     if (e.key === "left") {
    //         offset = new paper.Point(-15 / paper.view.zoom, 0);
    //         paper.view.center = paper.view.center.add(offset);
    //     }
    //     if (e.key === "right") {
    //         offset = new paper.Point(15 / paper.view.zoom, 0);
    //         paper.view.center = paper.view.center.add(offset);
    //     }
    //     if (e.key === "delete" || e.key === "backspace") {
    //         var selected_items = paper.project.getItems({ selected: true });
    //
    //         if (selected_items.length > 0) {
    //             for (var path of selected_items) {
    //                 path.selected = true;
    //                 path.remove();
    //                 // this.adding_points_to_this_path = null;
    //                 // rubberband.visible = false;
    //                 // this.lastPointAdded = null;
    //                 // paper.project.deselectAll();
    //             }
    //         }
    //     }
    //     if (e.key === "control" && _this.adding_points_to_this_path && rubberband.visible && _this.last_onMouseMove_event_data) {
    //
    //         paper.view.emit('mousemove', _this.last_onMouseMove_event_data);
    //     }
    // }

    // paper.view.onKeyUp = function (e) {
    //     if (e.key === "control" && _this.adding_points_to_this_path && rubberband.visible && _this.last_onMouseMove_event_data) {
    //
    //         setTimeout(paper.view.emit('mousemove', _this.last_onMouseMove_event_data), 50);
    //     }
    // }

    var hitOptions = {
        // Trigger hit only on 'fill' part of the path with 0 tolerance
        segments: false,
        stroke: false,
        fill: true,
        tolerance: 0,
    };

    let last_hover = null;

    var tool = new paper.Tool(); // Again manually. Life is much easier with script type="text/paperscript"
    tool.onMouseMove = function (event) {
        // Installig paperjs event
        var x = event.point.x;
        var y = event.point.y;

        // document.getElementById("xycoordinates").innerHTML = "Coordinates: (" + x + "," + y + ")";

        var hitResult = paper.project.activeLayer.hitTest(event.point, hitOptions); // isPointInPath

        if (last_hover && (!hitResult || hitResult.item !== last_hover)) {
            //
            if (last_hover.shadow) {
                item.shadowColor = last_hover.shadow.shadowColor;
                item.shadowBlur = last_hover.shadow.shadowBlur;
                item.shadowOffset = last_hover.shadow.shadowOffset;
            } else {
                last_hover.shadowColor = null;
                last_hover.shadowBlur = 0;
            }
            // if (last_hover.fillColor) last_hover.fillColor.alpha = last_hover.fillColorAlpha_o?last_hover.fillColorAlpha_o:1;
            last_hover = null;
        }

        if (hitResult && hitResult.item !== last_hover) {
            //
            let name = GetName(hitResult.item);
            if (name) {
                // document.body.style.cursor = "pointer";
                paper.view.element.style.setProperty("cursor", "pointer");
                var item = hitResult.item;
                //
                if (!item.shadow)
                    item.shadow = {
                        shadowColor: item.shadowColor,
                        shadowBlur: item.shadowBlur,
                        shadowOffset: item.shadowOffset,
                    };
                // if (item.opacity = Number(item.opacity)*0.8;
                // else if (item.opacity_o>0.25) item.opacity = item.opacity_o*2;
                // else item.opacity = 0.75;
                // if (!item.fillColorAlpha_o) item.fillColorAlpha_o = item.fillColor.alpha;
                // if (item.fillColorAlpha_o > 0.4) item.fillColor.alpha = item.fillColorAlpha_o*0.75;
                // else item.fillColor.alpha = item.fillColorAlpha_o*3;
                //
                item.shadowColor = "green";
                item.shadowBlur = 20;
                item.shadowOffset = new paper.Point(0, 0);
                last_hover = item;
            }
        } else if (hitResult && hitResult.item === last_hover) {
            paper.view.element.style.setProperty("cursor", "pointer");
        } else {
            if (!window.dragging) paper.view.element.style.setProperty("cursor", "crosshair");
            if (window.dragging) paper.view.element.style.setProperty("cursor", "all-scroll");
        }
    };

    function GetName(item) {
        if (item) {
            if (item.name) return item.name;
            if (item.parent && item.parent.name && !item.parent.name.startsWith("area")) return item.parent.name;
            if (item.parent.parent && item.parent.parent.name && !item.parent.parent.name.startsWith("area"))
                return item.parent.parent.name;
        }
        return null;
    }

    var qqCanvas = document.getElementById("qqCanvas");
    if (qqCanvas)
        qqCanvas.addEventListener("wheel", function (e) {
            var delta = e.deltaY;
            var zoom = paper.view.zoom * (1 - delta / 4500);

            // zoom = zoom * (1 + delta / 5500);

            if (zoom > 7) zoom = 7;
            if (zoom < 0.03) zoom = 0.03;
            paper.view.zoom = zoom;

            offset_grid();

            e.preventDefault();
            e.stopPropagation();
        });
    if (qqCanvas)
        qqCanvas.addEventListener("contextmenu", function (e) {
            e.preventDefault();
        });
}

export function toggleGrid(show_grid) {
    // let current_bg = document.getElementById("qqCanvas").style.backgroundImage;
    // if (!window.paper_bg_default && current_bg && current_bg !== "none") window.paper_bg_default = document.getElementById("qqCanvas").style.backgroundImage;

    if (!show_grid) document.getElementById("qqCanvas").style.backgroundImage = "none";
    else document.getElementById("qqCanvas").style.removeProperty("background-image");
}

export function ClosePaper() {
    paper.remove();
    paper.clear();
    window.svg = null;
}

function SetQQAttributes(in_item) {
    for (let key in in_item.children) {
        let item = in_item.children[key];

        if (item?.name?.includes && item.name.includes("type:origin")) {
            window.paper_origin = item.position;

            window.origin_convert = (pt) => {
                let out_pt = { ...pt };
                if (window.paper_origin) {
                    out_pt.x = out_pt.x - window.paper_origin.x;
                    out_pt.y = -(out_pt.y - window.paper_origin.y);
                }
                return out_pt;
            };
            window.origin_convert_reverse = (pt) => {
                let out_pt = { ...pt };
                if (window.paper_origin) {
                    out_pt.x = out_pt.x + window.paper_origin.x;
                    out_pt.y = window.paper_origin.y - out_pt.y;
                }
                return out_pt;
            };
        }

        if (item?.segments?.length && item.segments.length === 4 && item.fillColor.red === 0.6980392156862745) {
            //breacket bg;
            item.fillColor.alpha = 0.05;
        }
        // setting defaults
        item.areaIndex = -1;
        item.areaNumber = -1;
        if (window?.job?.AreaSpecifications && window?.job?.AreaSpecifications.length === 1) {
            item.areaIndex = 0;
            item.areaNumber = 1;
        }
        item.ref = "";
        item.lengthQQ = 0;
        let kvp_base = item.name ? item.name : item.parent.name ? item.parent.name : key;
        let kvps = kvp_base ? kvp_base.split(",") : [];
        if (kvp_base && kvps.length > 0) {
            for (let kvp of kvps) {
                let split = kvp.split(":");
                let this_key = split[0];
                let value = split[1];

                if (this_key === "len") item.lengthQQ = Number(value);
                else if (this_key === "area") {
                    item.areaIndex = Number(value) - 1;
                    item.areaNumber = Number(value);
                } else if (this_key === "name") item.nameQQ = value;
                else if (this_key === "type") item.typeQQ = value;
                else if (this_key === "eng_capacity") item.eng_capacity = toNumber(value);
                else if (value !== undefined && value.toUpperCase && value.toUpperCase() === "FALSE")
                    item[this_key] = false;
                else if (value !== undefined && value.toUpperCase && value.toUpperCase() === "TRUE")
                    item[this_key] = true;
                else if (value !== undefined) item[this_key] = value;
                else item[this_key] = true;
            }
            //
        }

        if (item.sel_type === "downlight") item.is_downlight = true;
        if (item.sel_type === "downlight_flashing") item.is_downlight_flashing = true;
        if (item.sel_type === "fan") item.is_fan = true;

        if (["sheet", "skylight"].includes(item.sel_type)) {
            item.is_roofsheet = true;
            if (item.sel_type === "skylight") item.is_skylight = true;
            // if (COMMON.Contains(key, ["Ampelite", "Polycarbonate", "Alsynite"])) item.is_skylight = true;
        }
        if (key.includes("name:sheet_section_")) item.remove();
        if (item.sel_type === "gutter") item.is_gutter = true;

        if (item.sel_type === "attachment") {
            if (item.typeQQ === "attachment_ghost") item.is_attachment_ghost = true;
            else item.is_attachment = true;

            if (item.ref === "unknown") {
                if (item.ref2.startsWith("CBR")) item.ref = "BackRight-Attachment";
                if (item.ref2.startsWith("CBL")) item.ref = "BackLeft-Attachment";
                if (item.ref2.startsWith("CFR")) item.ref = "FrontRight-Attachment";
                if (item.ref2.startsWith("CFL")) item.ref = "FrontLeft-Attachment";
            }
        }

        if (
            item.nameQQ &&
            (item.nameQQ.startsWith("JMB") || item.nameQQ.startsWith("UCE") || item.nameQQ.startsWith("BK50"))
        ) {
            item.typeQQ = "riser_bracket";
            item.sel_type = "riser_bracket";
        }

        if (item.sel_type && item.sel_type.includes("ceiling_fan_point")) {
            item.is_ceiling_fan_point = true;
        }
        if (item.sel_type === "splice") {
            item.is_splice = true;
        }

        if (item.sel_type && item.sel_type.includes("ceiling_fan_point")) {
            item.is_ceiling_fan_point = true;
        }

        if (item.sel_type && item.sel_type.includes("beam")) {
            item.is_beam = true;
        }

        if (item.typeQQ && item.typeQQ.includes("sheet_outline")) {
            item.is_sheet_outline = true;
        }

        if (
            (item.typeQQ && item.typeQQ.includes("wall_line")) ||
            (item.sel_type && item.sel_type.includes("wall_line"))
        ) {
            item.is_wall_line = true;
        }

        if (item.typeQQ && item.typeQQ.includes("sheet_laying_point")) {
            item.sheet_laying_point = true;
        }

        if (item.sel_type && item.sel_type === "brace") {
            item.is_brace = true;
        }

        if ((item.sel_type && item.sel_type === "slat_post") || item.typeQQ === "slat_post") {
            item.sel_type = "slat_post";
            item.typeQQ = "slat_post";
            item.is_post = false;
        } else if ((item.sel_type && item.sel_type === "post") || item.typeQQ === "post") {
            item.is_post = true;
        }

        if (item.sel_type && item.sel_type === "note") {
            item.is_note = true;
        }

        if (item.warning) {
            item.has_warning = true;
        }
        if (item.error) {
            item.has_error = true;
        }

        if (item.typeQQ === "post_label") {
            item.is_post_label = true;
        }
        if (item.typeQQ === "bracket_label") {
            item.is_bracket_label = true;
        }
        if (item.typeQQ === "slat_panel") {
            item.is_slat = true;
            item.sel_type = "slat_panel";
            // if (!item.ref) item.ref="(0,0,0);(0,0,0)";
        }

        if (
            (item.typeQQ && item.typeQQ.includes("slat_post")) ||
            (item.sel_type && item.sel_type.includes("slat_post"))
        ) {
            item.is_slat_post = true;
        }

        if (item.typeQQ === "slat_label") {
            item.sel_type = "slat_label";
            // if (!item.ref) item.ref="(0,0,0);(0,0,0)";
        }

        if (item.typeQQ === "downpipe") {
            item.is_downpipe = true;
            if (!item.ref) item.ref = "Auto";
        }

        if (item.typeQQ === "cutout_ghost") {
            item.is_cutout = true;
        }
        if (!item?.ref2 || item?.ref2 === true) item.ref2 = "";

        if (item?.ref2 && item.ref2.startsWith && (item.ref2.startsWith("CB") || item.ref2.startsWith("CF"))) {
            item.is_cutout = true;
        }

        if ((item.sel_type && item.sel_type === "slat_post_footing") || item.typeQQ === "slat_post_footing") {
            item.sel_type = "slat_post_footing";
            item.typeQQ = "slat_post_footing";
            item.is_footing = false;
        } else if (item.sel_type && item.sel_type === "post_footing") {
            item.is_footing = true;
        }

        if (
            (item.typeQQ && item.typeQQ.startsWith("dimension")) ||
            (item.parent && item.parent.typeQQ && item.parent.typeQQ.startsWith("dimension"))
        ) {
            item.is_dimension = true;
            item.sel_type = "dimension";

            if (item.typeQQ === "dimension/overall" && item?.content && !item.ref) {
                let depth = toNumber(GetSpec(item.areaIndex, "SHAPE", "Depth", -1));
                let length = toNumber(GetSpec(item.areaIndex, "SHAPE", "Length", -1));
                let dim_value = toNumber(item.content);

                if (depth === dim_value) item.ref = "Depth";
                else if (length === dim_value) item.ref = "Length";
            }
        }

        if (item.ref === "unknown" && item?.ref2?.startsWith && item.ref2.startsWith("C")) {
            if (item.ref2 === "CFL") {
                item.ref = "FrontLeft-Attachment";
            }
            if (item.ref2 === "CFR") {
                item.ref = "FrontRight-Attachment";
            }
            if (item.ref2 === "CBL") {
                item.ref = "BackLeft-Attachment";
            }
            if (item.ref2 === "CBM") {
                item.ref = "BackMid-Attachment";
            }
            if (item.ref2 === "CBR") {
                item.ref = "BackRight-Attachment";
            }
        }

        if (item?.warning_msg) {
            item.warning_msg = item.warning_msg.replaceAll("_", " ").replaceAll("$$COMMA$$", ",");
        }
        if (item?.warning) {
            item.warning = item.warning.replaceAll("_", " ").replaceAll("$$COMMA$$", ",");
        }
        if (item?.error_msg) {
            item.error_msg = item.error_msg.replaceAll("_", " ").replaceAll("$$COMMA$$", ",");
        }
        if (item?.error) {
            item.error = item.error.replaceAll("_", " ").replaceAll("$$COMMA$$", ",");
        }

        if (item.typeQQ === "barge_cap") {
            item.is_barge = true;
        }

        if (item.children) {
            item = SetQQAttributes(item);
        }

        // if (item.typeQQ === "gutter_label" || (item.children && item.children.length > 0 && item.children[0].typeQQ && item.children[0].typeQQ === "gutter_label")) {
        //     item.locked = true;
        //     if (item.children && item.children.length > 0 && item.children[0].typeQQ && item.children[0].typeQQ) item.children[0].locked = true;
        // }
    }

    return in_item;
}

export const GetItems = (parameters) => {
    if (window.svg) {
        return paper.project.getItems(parameters);
    }
    return null;
};

export function FormatSVGToJob() {
    if (window.svg) {
        window.base_font_factor = 100;
        window.svg = SetQQAttributes(window.svg);

        let deckMode = false;
        const carportMode = window?.job?.DesignParameters?.CarportMode === 1;
        if (window?.job?.DesignParameters?.DeckMode) deckMode = true;

        let louvreMode = false;
        if (window?.job?.DesignParameters?.LouvreMode) louvreMode = true;

        paper.project.getItems({ is_attachment: true }).forEach(function (item) {
            // paper.project.activeLayer.addChild(item.parent.parent);
            // item.parent.parent.sendToBack();
            // paper.project.activeLayer.addChild();

            item.parent.parent.sendToBack();
            item.parent.sendToBack();
            item.sendToBack();
            item.fillPattern = COMMON.BaseURL("images/hatching.png");
        });

        paper.project.getItems({ typeQQ: "cutout_ghost" }).forEach(function (item) {
            if (item.length > 2100) {
                if (!deckMode) item.visible = false;
            } else {
                item.parent.parent.sendToBack();
                item.parent.sendToBack();
                item.sendToBack();
            }
        });

        // Remove "IN GROUND" text from carport 2D plan view
        if (carportMode) {
            paper.project.getItems({ typeQQ: "post" }).forEach(function (item) {
                if (item instanceof paper.PointText && item.parent instanceof paper.Group) {
                    item.parent.remove();
                }
            });
        }

        paper.project.getItems({ typeQQ: "attachment_ghost" }).forEach(function (item) {
            if (toNumber(item?.lengthQQ) > 500) {
                item.parent.parent.sendToBack();
                item.parent.sendToBack();
                item.sendToBack();
            }
        });

        if (!louvreMode)
            paper.project.getItems({ is_roofsheet: true }).forEach(function (item) {
                // paper.project.activeLayer.addChild(item.parent.parent);
                // item.parent.parent.sendToBack();
                // paper.project.activeLayer.addChild();
                item.parent.parent.sendToBack();
                item.parent.sendToBack();
                item.sendToBack();
                // item.opacity = 0.5;
            });

        if (deckMode)
            paper.project.getItems({ typeQQ: "cutout_ghost" }).forEach(function (item) {
                if (item.length > 2100) {
                    item.parent.parent.sendToBack();
                    item.parent.sendToBack();
                    item.sendToBack();
                }
            });

        paper.project.getItems({ is_beam: true }).forEach(function (item) {
            paper.project.activeLayer.addChild(item);
        });
        paper.project.getItems({ typeQQ: "sheet_label" }).forEach(function (item) {
            paper.project.activeLayer.addChild(item);
        });
        paper.project.getItems({ typeQQ: "gutter_label" }).forEach(function (item) {
            paper.project.activeLayer.addChild(item);
        });
        paper.project.getItems({ is_bracket_label: true }).forEach(function (item) {
            paper.project.activeLayer.addChild(item);
        });

        let post_data = {};
        paper.project.getItems({ is_post: true }).forEach(function (item) {
            paper.project.activeLayer.addChild(item);
            // item.locked = true;
            let split = item.ref.split("/");
            if (split.length > 1) {
                let ref = split[0] + "/" + split[1] + ")";
                post_data[ref] = {
                    ref: item.ref,
                    ref2: item.ref2,
                    ref3: item?.ref3,
                    ref4: item?.ref4,
                    areaIndex: item.areaIndex,
                    areaNumber: item.areaNumber,
                    adj: item.adj,
                    code: item.code,
                    colour: item.colour,
                    lengthQQ: item.lengthQQ,
                    nameQQ: item.nameQQ,
                };
            }
        });

        paper.project.getItems({ is_footing: true }).forEach(function (item) {
            if (post_data[item.ref]) {
                item.post_data = post_data[item.ref];
            }
            paper.project.activeLayer.addChild(item);
        });

        paper.project.getItems({ is_post: true }).forEach(function (item) {
            paper.project.activeLayer.addChild(item);
        });

        // paper.project.getItems({ is_footing: true }).forEach(function (item) {
        // });
        paper.project.getItems({ is_downpipe: true }).forEach(function (item) {
            paper.project.activeLayer.addChild(item);
        });

        // );
        // get roofsheet labels
        let paper_origin = new paper.Point(0, 0);

        paper.project.getItems({ class: paper.TextItem }).forEach(function (item) {
            if (window.LYSAGHT) {
                item.fontSize = item.fontSize * 0.8;
                item.fontFamily = "'canada-type-gibson', " + item.fontFamily;
            }
            if (item.label_pos_ref && item.name !== "type:origin") {
                let distance = item.point.getDistance(paper_origin);
                if (distance < 1) {
                    let pnt = COMMON.getPointForRef(item.label_pos_ref);
                    pnt = window.origin_convert(pnt);
                    item.point = new paper.Point(pnt.x, pnt.y);
                }
            }
            item.orig_point = new paper.Point(item.point);
        });

        let warning_and_error_items = paper.project.getItems({
            has_warning: true,
        });
        warning_and_error_items.push.apply(
            warning_and_error_items,
            paper.project.getItems({
                has_error: true,
            })
        );

        warning_and_error_items.forEach(function (item) {
            let title = "";
            let message = "";
            // if (item?.warning === "FlatHipBeamPostClash") {
            //     title = "Post position error";
            //     message = "You cannot have a post in the corner of a hip area join. Please move this post.";
            // }
            if (item?.warning_msg) {
                title = item.warning;
                message = item.warning_msg;
            } else if (item?.error_msg) {
                title = item.error;
                message = item.error_msg;
            }
            if (title && message) {
                paper.project.activeLayer.warning_circle = new paper.Path.Circle({
                    center: item.position,
                    radius: 100,
                    fillColor: null,
                    strokeColor: "#9a560d",
                    strokeWidth: 30,
                    dashArray: [30, 20],
                });
                paper.project.activeLayer.warning_circle.name = "warning_circle";
                paper.project.activeLayer.warning_circle.is_warning_element = true;

                let warning_exists = false;
                if (item.collate !== false) {
                    paper.project.getItems({ warning_title: title }).forEach(function (warning_item) {
                        if (warning_item?.warning_title === title) {
                            warning_exists = true;

                            paper.project.activeLayer.warning_line = new paper.Path(
                                item.position,
                                warning_item.position
                            );
                            let warning_line = paper.project.activeLayer.warning_line;
                            warning_line.name = "warning_line";
                            warning_line.is_warning_element = true;
                            warning_line.strokeColor = "red";
                            warning_line.strokeWidth = 6;
                            warning_line.dashArray = [3, 3];
                            warning_line.visible = true;
                            warning_line.bringToFront();
                        }
                    });
                }

                if (!warning_exists) {
                    let icon_url = COMMON.BaseURL(
                        item?.error_msg ? "images/icons8-error-48.png" : "images/icons8-warning-48.png"
                    );
                    paper.project.activeLayer.raster_warning = new paper.Raster(icon_url);
                    let rasterWarning = paper.project.activeLayer.raster_warning;
                    rasterWarning.warning_title = title;
                    rasterWarning.is_warning_element = true;
                    let pnt = item.position.add(new paper.Point(300, 200));
                    rasterWarning.position = pnt;
                    rasterWarning.onLoad = function () {
                        paper.project.activeLayer.warning_line = new paper.Path(item.position, pnt);
                        let warning_line = paper.project.activeLayer.warning_line;
                        warning_line.name = "warning_line";
                        warning_line.is_warning_element = true;
                        warning_line.strokeColor = "red";
                        warning_line.strokeWidth = 6;
                        warning_line.dashArray = [3, 3];
                        warning_line.visible = true;
                        warning_line.bringToFront();

                        rasterWarning.name = "warning_icon";
                        rasterWarning.scale(7);
                        rasterWarning.opacity = 1.0;
                        rasterWarning.bringToFront();

                        rasterWarning.onFrame = function (event) {
                            if (this.glow_up) this.opacity += 0.008;
                            else this.opacity -= 0.008;
                            if (this.opacity < 0.6) this.glow_up = true;
                            if (this.opacity > 1.0) this.glow_up = false;

                            if (this.rotate_back) this.rotate(-0.1);
                            else this.rotate(0.1);
                            if (this.rotation > 2) this.rotate_back = true;
                            if (this.rotation < -2) this.rotate_back = false;
                        };

                        rasterWarning.onMouseEnter = function (event) {
                            rasterWarning.scale(1.5);
                            paper.view.element.style.setProperty("cursor", "pointer");
                        };
                        rasterWarning.onMouseLeave = function (event) {
                            rasterWarning.scale(2 / 3);
                            paper.view.element.style.setProperty("cursor", "crosshair");
                        };

                        if (message.includes("/n")) {
                            //split for line breakInside:
                            let message_split = message.split("/n");
                            message = [];
                            let first = true;
                            for (let str of message_split) {
                                message.push(<p>{str}</p>);
                                first = false;
                            }
                        }

                        rasterWarning.onClick = function (event) {
                            window.dispatch({
                                type: "SHOW_DIALOG",
                                value: {
                                    title: (
                                        <>
                                            <img
                                                src={icon_url}
                                                style={{
                                                    verticalAlign: "middle",
                                                }}
                                            />{" "}
                                            {title}
                                        </>
                                    ),
                                    message: message,
                                    // primaryActionText: primaryActionText,
                                    // primaryAction: primaryAction,
                                    // secondaryActionText: secondaryActionText,
                                    // secondaryAction: secondaryAction,
                                },
                            });
                        };
                    };
                }
            }
        });
    }
}
// export function WipeSkylights(areaIndex = -1) {
//     if (window.svg) {
//         for (let key in window.svg.children) {
//             let item = window.svg.children[key];
//
//             if (item.is_skylight && (areaIndex === -1 || areaIndex === item.areaIndex)) item.is_skylight = false;
//         }
//     }
//     return UpdateRoofSheets();
// }

export function UpdateSkylights2D() {
    if (window.svg) {
        let skylightsAll = GetSpecAllAreas("SKYLIGHTS", null, []);
        let roofsheets = paper.project.getItems({ is_roofsheet: true });
        roofsheets.forEach(function (item) {
            item.is_skylight = false;
            item.sel_type = "sheet";
            item.fillColorAlpha_o = null;
        });

        //

        skylightsAll.forEach(function (area_skylights, areaIndex) {
            area_skylights.forEach(function (skylight) {
                let ref = skylight.Section + "/" + skylight.Offset;
                let ref2 =
                    skylight?.Index !== undefined && toNumber(skylight?.Index) >= 0
                        ? skylight.Section + "/" + skylight.Index
                        : null;

                roofsheets.forEach(function (item) {
                    if (areaIndex === -1 || areaIndex === item.areaIndex) {
                        if (ref2 && item.ref2) {
                            if (ref2 === item.ref2) {
                                item.is_skylight = true;
                            }
                        } else if (ref === item.ref) {
                            item.is_skylight = true;
                        }
                        // item.is_skylight = false;
                        // item.sel_type = "sheet";
                        // item.fillColorAlpha_o = null;
                    }
                });
            });
        });
    }
    UpdateRoofSheets();
    window.dispatch(updateLayout2D());
}

export function WipeSkylights(areaIndex = -1) {
    if (window.svg) {
        paper.project.getItems({ is_skylight: true }).forEach(function (item) {
            if (areaIndex === -1 || areaIndex === item.areaIndex) {
                item.is_skylight = false;
                item.sel_type = "sheet";
                item.fillColorAlpha_o = null;
            }
        });
    }
    UpdateRoofSheets();
}

export function GetSkylights() {
    let skylights = {};
    if (window?.job?.AreaSpecifications)
        for (let area of window.job.AreaSpecifications) {
            skylights[area.AreaIndex] = [];
        }
    if (window.svg) {
        paper.project.getItems({ is_skylight: true }).forEach(function (item) {
            if (item.areaIndex !== null && !skylights?.[item.areaIndex]) skylights[item.areaIndex] = [];
            let index = item?.ref2 ? item.ref2.split("/")[1] : -1;
            skylights[item.areaIndex].push({
                Section: item.ref.split("/")[0],
                Offset: item.ref.split("/")[1],
                Index: index,
            });
        });
    }

    return skylights;
}

export function GetRoofColoursAreasHTML() {
    let roofsheet_colour_in_areas = GetSpecAllAreas(
        BASIC_SPECS_SECTIONS.ROOF_SHEETING,
        "RoofSheetColour",
        "Classic Cream/Grey"
    );
    let roofrolling_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "ReverseRoll", false);
    roofsheet_colour_in_areas.forEach(function (value, index, array) {
        let reverse = roofrolling_in_areas[index];
        let side = 0;
        if (reverse) side = 1;

        array[index] = GetHTMLColour(value)[side];
    });
    return roofsheet_colour_in_areas;
}
export function GetRoofColoursUndersideAreasHTML() {
    let roofsheet_colour_in_areas = GetSpecAllAreas(
        BASIC_SPECS_SECTIONS.ROOF_SHEETING,
        "RoofSheetColour",
        "Classic Cream/Grey"
    );
    let roofrolling_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "ReverseRoll", false);
    roofsheet_colour_in_areas.forEach(function (value, index, array) {
        let reverse = roofrolling_in_areas[index];
        let side = 1;
        if (reverse) side = 0;

        array[index] = GetHTMLColour(value)[side];
    });
    return roofsheet_colour_in_areas;
}

export function UpdateRoofSheets() {
    if (window.svg) {
        let roofsheet_colour_in_areas_HTML = GetRoofColoursAreasHTML();

        let GutterCol_in_areas = GetSpecAllAreas(
            BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES,
            "GutterCol",
            "Classic Cream"
        );
        let gutter_colour_html_in_areas = [...GutterCol_in_areas];
        let gutter_colour_html_contrasttext_in_areas = [];
        gutter_colour_html_in_areas.forEach(function (value, index, array) {
            array[index] = GetHTMLColour(value)[1];
            gutter_colour_html_contrasttext_in_areas[index] = GetHTMLColour(value)[2];
        });

        let GutterType_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "GutterType", "");
        let GutterSlottedGutter_in_areas = GetSpecAllAreas(
            BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES,
            "SlottedGutter",
            ""
        );
        let GutterGutterWithReturn_in_areas = GetSpecAllAreas(
            BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES,
            "GutterWithReturn",
            ""
        );
        let GutterF_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "GutterF", "");
        let GutterL_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "GutterL", "");
        let GutterR_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "GutterR", "");
        let GutterB_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "GutterB", "");
        let BoxGutterColour_in_areas = GetSpecAllAreas(
            BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES,
            "BoxGutterColour",
            ""
        );
        let BoxGutterColour_html_in_areas = [...BoxGutterColour_in_areas];
        BoxGutterColour_html_in_areas.forEach(function (value, index, array) {
            array[index] = GetHTMLColour(value)[1];
        });

        let AttachmentTop_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.ATTACHMENT, "AttachmentTop", 0);

        // get roofsheets

        const ROOFSHEET__MESH_MODE = window.app.designer.designer3D[APP.ROOFSHEET__MESH_MODE];
        let roofsheet_grouptype_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "RoofGroupType", "");
        let roofsheet_data_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "RoofSheetData", {});

        paper.project.getItems({ typeQQ: "sheet" }).forEach(function (item) {
            if (ROOFSHEET__MESH_MODE === "Hidden") item.visible = false;
            else item.visible = true;
            // if (item.hasStroke()) {
            // }
            // item.dashArray = [30, 60];
            // item.strokeColor = "red";
        });

        let is_cyclonic = false;
        let region = window.job?.SiteParameters?.WindData?.WindZoneAS1170?.region;
        if (region === "C" || region === "D") {
            is_cyclonic = true;
        }

        // P = panel spacing (not from ends)
        // PE = panel spacing (from ends)
        // PEC = panel spacing (from ends in Cyclonic)
        const skylight_rules = {
            "FLATDEK 310": ["2PE", "3P"],
            FLATDEK: ["2PE", "3P"],
            "FLATDEK II": ["1PE", "2P"],
            TRIMDEK: ["1PE", "2PEC", "2P"],
            SPANDEK: ["1PE", "2PEC", "2P"],
            "CUSTOM ORB": ["1PE", "2PEC", "2P"],
            "KLIP-LOK": ["1PE", "1P"],
            "Cent 310 Deck": ["1PE", "1P"],
            "Bondor Solarspan": ["1PE", "1P"],
        };

        // Function to check spacing rules for skylights
        function checkSkylightSpacing(rule, index, roofsheets) {
            const spacingValue = parseInt(rule.replace(/[^\d]/g, ""), 10); // Extract number from rule (e.g., "2P" -> 2)
            const spacingType = rule.replace(/[0-9]/g, ""); // Get the type of spacing (e.g., "P", "PE")

            // Extract position of the current sheet
            const currentSheetPos = parseInt(roofsheets[index].nameQQ.split("_")[2], 10);

            if (!is_cyclonic && spacingType === "PEC") return true; // Dont change

            // spacing type PE|PEC
            if (["PE", "PEC"].includes(spacingType)) {
                if (currentSheetPos - spacingValue <= 0 || currentSheetPos + spacingValue > roofsheets.length) {
                    return false;
                }
            }

            // Check if the previous sheets up to spacingValue positions to the left contain a skylight
            let leftSheetPositions = [];
            for (let i = 1; i <= spacingValue; i++) {
                const leftSheetPos = currentSheetPos - i;
                if (leftSheetPos >= 1) leftSheetPositions.push(leftSheetPos); // Ensure we don't go below 1
            }

            // Check if the next sheets up to spacingValue positions to the right contain a skylight
            let rightSheetPositions = [];
            for (let i = 1; i <= spacingValue; i++) {
                const rightSheetPos = currentSheetPos + i;
                if (rightSheetPos <= roofsheets.length) rightSheetPositions.push(rightSheetPos); // Ensure we don't go beyond the length
            }

            // Check the left positions for skylights
            for (const leftPos of leftSheetPositions) {
                const leftSheet = roofsheets.find((sheet) => parseInt(sheet.nameQQ.split("_")[2], 10) === leftPos);
                if (leftSheet && leftSheet.sel_type === "skylight") {
                    return false; // Found a skylight too close on the left side
                }
            }

            // Check the right positions for skylights
            for (const rightPos of rightSheetPositions) {
                const rightSheet = roofsheets.find((sheet) => parseInt(sheet.nameQQ.split("_")[2], 10) === rightPos);
                if (rightSheet && rightSheet.sel_type === "skylight") {
                    return false; // Found a skylight too close on the right side
                }
            }

            return true; // Skylight passes the spacing check
        }

        // Loop through all the roof sheets to check their validity
        let roofsheets = paper.project.getItems({ is_roofsheet: true }); // Assume paper.project.getItems gets all roof sheets

        roofsheets.forEach(function (item, index, array) {
            item.is_next_to_skylight = false;
            item.fillColorAlpha_o = null;
            item.fillColor = roofsheet_colour_in_areas_HTML[item.areaIndex];

            if (ROOFSHEET__MESH_MODE !== "Render") {
                item.visible = false;
            } else {
                item.visible = true;
                if (item?.areaIndex !== undefined) {
                    let area_index = item?.areaIndex;
                    if (roofsheet_grouptype_in_areas[area_index] === "Polycarbonate") {
                        item.fillColor.alpha = 0.6;
                        item.fillColorAlpha_o = 0.6;
                    }
                }
            }

            // Get the roofsheet type for rules (whether or not it is a skylight)
            const roofsheetType = roofsheet_grouptype_in_areas[item?.areaIndex] || "Unknown"; // Default to "Unknown" if undefined

            // Get the skylight rules for this roofsheet type
            const rules = skylight_rules[roofsheetType] || [];

            // Loop through all rules for this roofsheet type
            let isValidSkylight = true;
            for (const rule of rules) {
                if (!checkSkylightSpacing(rule, index, roofsheets)) {
                    isValidSkylight = false;
                    break; // If any rule is violated, stop checking further
                }
            }

            // If the skylight is invalid based on the rules, flag it
            if (!isValidSkylight) {
                item.sky_light_disabled = true;
                if (item.is_skylight) {
                    item.is_skylight = false;
                    item.sel_type = "sheet";
                }
                item.sky_light_disabled_message = `Can not add sheet here`;
            } else {
                item.sky_light_disabled = false;
            }
        });

        // get roofsheet labels
        paper.project.getItems({ typeQQ: "sheet_label" }).forEach(function (item) {
            item.fontWeight = 600;
            if (ROOFSHEET__MESH_MODE === "Hidden") item.visible = false;
            else item.visible = true;
        });

        // get skylights
        let skylight_type_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "SkylightType", "");
        let skylight_colour_in_areas = GetSpecAllAreasColourHTML(
            BASIC_SPECS_SECTIONS.ROOF_SHEETING,
            "SkylightColour",
            "Clear"
        );

        paper.project.getItems({ is_skylight: true }).forEach(function (item, index, array) {
            if (skylight_type_in_areas[item.areaIndex] !== "") {
                let coverage = roofsheet_data_in_areas?.[item.areaIndex]?.coverage
                    ? roofsheet_data_in_areas?.[item.areaIndex]?.coverage
                    : 760;
                let skylight_spacing = roofsheet_data_in_areas?.[item.areaIndex]?.skylight_spacing
                    ? roofsheet_data_in_areas?.[item.areaIndex]?.skylight_spacing
                    : 0;

                item.fillColor = skylight_colour_in_areas[item.areaIndex];
                if (!item.fillColor) {
                }
                if (item?.fillColor) item.fillColor.alpha = 0.6;
                item.fillColorAlpha_o = 0.6;

                if (skylight_spacing > 0) {
                    let ref = item.ref2.split("/");
                    let section = ref[0];
                    let offset_index = toNumber(ref[1]);

                    roofsheets.forEach(function (sheet, index, array) {
                        // let ref2_split = sheet.ref.split("/");
                        // let section2 = ref2_split[0];
                        // let offset2 = toNumber(ref2_split[1]);

                        // let diff = Math.abs(offset2 - offset);
                        // if (section == section2 && diff > 1 && diff < coverage * (0.6 + skylight_spacing)) {
                        //     sheet.is_next_to_skylight = true;
                        // }

                        let ref2_split = sheet.ref2.split("/");
                        let section2 = ref2_split[0];
                        let offset_index2 = toNumber(ref2_split[1]);

                        if (section == section2) {
                            if (offset_index == offset_index2) {
                                //ignore, the same sheet
                            } else if (Math.abs(offset_index - offset_index2) <= skylight_spacing) {
                                //ignore, the same sheet
                                sheet.is_next_to_skylight = true;
                            }
                        }
                    });
                }
            }
            // if (item.areaIndex !== null && skylights[item.areaIndex] === null) skylights[item.areaIndex] = [];
            // skylights[item.areaIndex].push({
            //     Section: item.ref.split('/')[0],
            //     Offset: item.ref.split('/')[1]
            // });
        });

        // get gutters

        paper.project.getItems({ is_gutter: true }).forEach(function (item, index, array) {
            let areaIndex = [Number(item.areaIndex)];
            if (item.ref && item.ref.includes("GutterF") && GutterF_in_areas[areaIndex] === 0) {
                if (item.material && item.material === "Centenary Box Gutter")
                    item.fillColor = BoxGutterColour_html_in_areas[areaIndex];
                else item.fillColor = gutter_colour_html_in_areas[areaIndex];
                if (item.fillColor) item.fillColor.alpha = 0;
            } else if (item.ref && item.ref.includes("GutterB") && GutterB_in_areas[areaIndex] === 0) {
                if (item.material && item.material === "Centenary Box Gutter")
                    item.fillColor = BoxGutterColour_html_in_areas[areaIndex];
                else item.fillColor = gutter_colour_html_in_areas[areaIndex];
                if (item.fillColor) item.fillColor.alpha = 0;
            } else if (item.ref && item.ref.includes("GutterR") && GutterR_in_areas[areaIndex] === 0) {
                if (item.material && item.material === "Centenary Box Gutter")
                    item.fillColor = BoxGutterColour_html_in_areas[areaIndex];
                else item.fillColor = gutter_colour_html_in_areas[areaIndex];
                if (item.fillColor) item.fillColor.alpha = 0;
            } else if (item.ref && item.ref.includes("GutterL") && GutterL_in_areas[areaIndex] === 0) {
                if (item.material && item.material === "Centenary Box Gutter")
                    item.fillColor = BoxGutterColour_html_in_areas[areaIndex];
                else item.fillColor = gutter_colour_html_in_areas[areaIndex];
                if (item.fillColor) item.fillColor.alpha = 0;
            } else {
                if (item.material && item.material === "Centenary Box Gutter")
                    item.fillColor = BoxGutterColour_html_in_areas[areaIndex];
                else item.fillColor = gutter_colour_html_in_areas[areaIndex];
                if (item.fillColor) item.fillColor.alpha = 1.0;
            }
            item.colour = GutterCol_in_areas[areaIndex];
        });

        // get attachmentsconst

        const ATTACHMENT_MESH_MODE = window.app.designer.designer3D[APP.ATTACHMENT_MESH_MODE];

        paper.project.getItems({ is_attachment: true }).forEach(function (item) {
            if (item.ref && item.ref.includes("GutterF") && GutterF_in_areas[item.areaIndex] === 0) {
                item.fillColor.alpha = 0;
            }
            if (ATTACHMENT_MESH_MODE === "Hidden") item.visible = false;
            else item.visible = true;
        });
        paper.project.getItems({ typeQQ: "attachment_label" }).forEach(function (item) {
            if (ATTACHMENT_MESH_MODE === "Hidden") item.visible = false;
            else item.visible = true;
        });

        let gutter_area_has_label = [];
        // get gutter labels
        let gutter_labels = paper.project.getItems({ typeQQ: "gutter_label" });
        // gutter_labels.forEach(function (item) {
        //     let areaIndex = [Number(item.areaIndex)];
        //     if (gutter_area_has_label[areaIndex] === true) {
        //         item.visible = false;
        //         return;
        //     }
        //     let label = GutterType_in_areas[areaIndex];
        //     if (GutterSlottedGutter_in_areas[areaIndex] === 1) label = "      " + label + " Slotted";
        //     if (GutterGutterWithReturn_in_areas[areaIndex] === 1) label = "     " + label + " w/Return";
        //     if (label !== null && label != "" && !item.content.includes("Box Gutter") && item.content.length > 5) {
        //         item.content = label;
        //         item.justification = 'center';
        //         item.fillColor = new paper.Color(gutter_colour_html_contrasttext_in_areas[areaIndex]);
        //         item.shadowColor = new paper.Color(gutter_colour_html_contrasttext_in_areas[areaIndex]==="#000000"?"#F5F5F5":"#000000");
        //         item.shadowBlur = 5;
        //         item.shadowOffset = new paper.Point(1, 1);
        //     };
        //     gutter_area_has_label[areaIndex] = true;
        // });

        const GUTTERS_AND_FLASHING_MESH_MODE = window.app.designer.designer3D[APP.GUTTERS_AND_FLASHING_MESH_MODE];

        gutter_labels.forEach(function (item) {
            if (GUTTERS_AND_FLASHING_MESH_MODE === "Hidden") item.visible = false;
            else item.visible = true;
        });
        paper.project.getItems({ typeQQ: "gutter" }).forEach(function (item) {
            if (GUTTERS_AND_FLASHING_MESH_MODE === "Hidden") item.visible = false;
            else item.visible = true;
        });
        paper.project.getItems({ is_gutter: true }).forEach(function (item) {
            if (GUTTERS_AND_FLASHING_MESH_MODE === "Hidden") item.visible = false;
            else if (GUTTERS_AND_FLASHING_MESH_MODE === "Mesh" && !item.strokeColor) item.visible = false;
            else if (GUTTERS_AND_FLASHING_MESH_MODE === "Mesh" && item.strokeColor) item.visible = false;
            else item.visible = true;
        });
    }
    // return skylights;
}

export function UpdateBeamsAndPosts(show_engineering = true, skip = 0) {
    if (window.skipUpdateBeams && window.skipUpdateBeams > 0) {
        window.skipUpdateBeams--;
        return;
    }
    window.skipUpdateBeams = skip;

    if (window.svg) {
        //

        // deleted beams to top

        paper.project.getItems({ is_beam: true, deleted: true }).forEach(function (item) {
            item.bringToFront();
            if (item.segments.length < 3) {
                item.strokeColor = new paper.Color("#88888888");
                item.strokeColor.alpha = 0.75;
                item.strokeWidth = window.LYSAGHT ? 50 : 65;
                item.strokeCap = "butt";
                item.dashArray = [80, 100];
            } else {
                item.fillColor = new paper.Color("#CCCCCC88");
                item.fillColor.alpha = 0.75;
            }
        });

        let roofsheet_colour_in_areas = GetSpecAllAreas(
            BASIC_SPECS_SECTIONS.ROOF_SHEETING,
            "RoofSheetColour",
            "Classic Cream"
        );
        let roofrolling_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "ReverseRoll", false);
        let RoofColour_html_contrasttext_in_areas = [];
        let RoofColour_html_shadow_in_areas = [];
        roofsheet_colour_in_areas.forEach(function (value, index, array) {
            let reverse = roofrolling_in_areas[index];
            let side = 1;
            if (reverse) side = 0;
            else if (value.includes("/") && !value.includes("/Grey")) side = 0;

            array[index] = GetHTMLColour(value)[side];
            RoofColour_html_contrasttext_in_areas[index] = reverse ? "#000000" : GetHTMLColour(value)[2];
            RoofColour_html_shadow_in_areas[index] = "black";

            let colour = tinycolor(RoofColour_html_contrasttext_in_areas[index]);
            if (colour.isDark()) RoofColour_html_shadow_in_areas[index] = "white";
            else RoofColour_html_shadow_in_areas[index] = "black";
        });

        let BeamCol_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamCol1", "Classic Cream");
        let BeamCol_html_in_areas = [...BeamCol_in_areas];
        BeamCol_html_in_areas.forEach(function (value, index, array) {
            if (value === "TBA") {
                array[index] = "#d85e83ff";
            } else {
                array[index] = GetHTMLColour(value)[1];
            }
        });
        let BeamCol2_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamCol2", "Classic Cream");
        let BeamCol2_html_in_areas = [...BeamCol2_in_areas];
        BeamCol2_html_in_areas.forEach(function (value, index, array) {
            if (value === "TBA") {
                array[index] = "#d85e83ff";
            } else {
                array[index] = GetHTMLColour(value)[1];
            }
        });
        let BeamCol3_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamCol3", "Classic Cream");
        let BeamCol3_html_in_areas = [...BeamCol3_in_areas];
        BeamCol3_html_in_areas.forEach(function (value, index, array) {
            if (value === "TBA") {
                array[index] = "#d85e83ff";
            } else {
                array[index] = GetHTMLColour(value)[1];
            }
        });
        let BeamCol4_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamCol4", "Classic Cream");
        let BeamCol4_html_in_areas = [...BeamCol4_in_areas];
        BeamCol4_html_in_areas.forEach(function (value, index, array) {
            if (value === "TBA") {
                array[index] = "#d85e83ff";
            } else {
                array[index] = GetHTMLColour(value)[1];
            }
        });
        let BeamType_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamType1", "");
        let BeamType2_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamType2", "");
        let BeamType3_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamType3", "");
        let BeamType4_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamType4", "");
        let PurlinSpacing_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "PurlinSpacing", "");

        let BeamMods_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMMODIFICATIONS, null, []);

        let beam_items = paper.project.getItems({
            typeQQ: "beam",
        });
        beam_items.push.apply(
            beam_items,
            paper.project.getItems({
                typeQQ: "beam1",
            })
        );
        beam_items.push.apply(
            beam_items,
            paper.project.getItems({
                typeQQ: "beam2",
            })
        );
        beam_items.push.apply(
            beam_items,
            paper.project.getItems({
                typeQQ: "beam3",
            })
        );
        beam_items.push.apply(
            beam_items,
            paper.project.getItems({
                typeQQ: "beam4",
            })
        );

        let toolopen = window.app.designer.designer3D[DRAWER_TOOLSET_EXPANDED];

        let show_eng = false;
        let deckMode = false;
        if (window?.job?.DesignParameters?.DeckMode) {
            deckMode = true;
        }

        const OVERSTRESS_FACTOR = 1.03;

        if (toolopen === BEAMS_AND_POSTS_TOOL) {
            let currentHashCode = GetShapeUpdateString(false, true);

            if (
                window?.job?.QuoteParameters?.ENGINEERING?.engineeringHashCode &&
                window.job.QuoteParameters.ENGINEERING.engineeringHashCode === currentHashCode
            )
                show_eng = true;
            if (deckMode) show_eng = true;
        }

        for (let item of beam_items) {
            let areaIndex = item.areaIndex;

            let mod_colour = null;
            if (BeamMods_in_areas[areaIndex]) {
                BeamMods_in_areas[areaIndex].forEach((element) => {
                    if (element.Ref === item.ref && element.Colour) {
                        mod_colour = element.Colour;
                    }
                });
            }

            if (mod_colour) item.fillColor = new paper.Color(GetHTMLColour(mod_colour)[1]);
            else if (item.typeQQ === "beam1") item.fillColor = new paper.Color(BeamCol_html_in_areas[areaIndex]);
            else if (item.typeQQ === "beam2") item.fillColor = new paper.Color(BeamCol2_html_in_areas[areaIndex]);
            else if (item.typeQQ === "beam3") item.fillColor = new paper.Color(BeamCol3_html_in_areas[areaIndex]);
            else if (item.typeQQ === "beam4") item.fillColor = new paper.Color(BeamCol4_html_in_areas[areaIndex]);
            else if (item.colour) item.fillColor = new paper.Color(GetHTMLColour(item.colour)[1]);

            if (show_engineering && show_eng) {
                if (deckMode) {
                    let engineering = window?.job?.QuoteParameters?.ENGINEERING?.Data?.[0];

                    let capacity = engineering?.BearerCapacity;
                    if (item.typeQQ === "beam2") {
                        capacity = engineering?.JoistCapacity;
                        // item.engineering = calculateDeckBeamCapacity(
                        //     "Joist",
                        //     BeamType2_in_areas[item.areaIndex],
                        //     item.lengthQQ,
                        //     PurlinSpacing_in_areas[item.areaIndex]
                        // );
                        // capacity = item.engineering.capacity_max;
                    }
                    if (item?.eng_capacity) capacity = item.eng_capacity;
                    if (!capacity || capacity > 1) item.fillColor = "red";
                    else if (capacity > 0.9) item.fillColor = "orange";
                    else item.fillColor = "green";
                } else {
                    item.Engineering = GetEngineeringResult(item.nameQQ);
                    if (item.Engineering) {
                        let split = item.Engineering.split("=");
                        let capacity = Number(split[0]) / OVERSTRESS_FACTOR;
                        if (capacity > 1) item.fillColor = "red";
                        else if (capacity > 0.9) item.fillColor = "orange";
                        else item.fillColor = "green";
                        item.beam_capacity = capacity;

                        if (split[2]) {
                            item.deflection = split[2];
                        }

                        paper.project.activeLayer.addChild(item);
                        // if (capacity > 0.9) item.content += " " + (Number(split[0])).toFixed(2) + " " + split[1];
                        // item.content += " " + Number(split[0]).toString(2) + split[1];
                        // item.content += " " + Number(split[0]).toString(2) + split[1];
                    }
                }
            }
        }
        for (let item of beam_items) {
            if (item?.beam_capacity > 1.0) {
                //ensure we show the red beams on top
                paper.project.activeLayer.addChild(item);
            }
        }
        let roofsheet_colour_in_areas_HTML = GetRoofColoursAreasHTML();

        if (show_engineering && show_eng) {
            //move bracket labels to top
            paper.project.getItems({ is_bracket_label: true }).forEach(function (item) {
                item.visible = true;
                let colour = tinycolor(roofsheet_colour_in_areas_HTML[item.areaIndex]);
                if (colour.getBrightness() < 120) {
                    item.fillColor = new paper.Color("#999999");
                } else {
                    item.fillColor = new paper.Color("#444444");
                }
                paper.project.activeLayer.addChild(item);
            });
        } else {
            //move bracket labels to top
            paper.project.getItems({ is_bracket_label: true }).forEach(function (item) {
                item.visible = false;
            });
        }
        //slats need to be on top of beams
        paper.project.getItems({ typeQQ: "slat_panel" }).forEach(function (item) {
            paper.project.activeLayer.addChild(item);
        });
        paper.project.getItems({ typeQQ: "slat_label" }).forEach(function (item) {
            paper.project.activeLayer.addChild(item);
        });

        let beam_label_items = paper.project.getItems({
            typeQQ: "beam_label",
        });
        beam_label_items.push.apply(
            beam_label_items,
            paper.project.getItems({
                typeQQ: "beam1_label",
            })
        );
        beam_label_items.push.apply(
            beam_label_items,
            paper.project.getItems({
                typeQQ: "beam2_label",
            })
        );
        beam_label_items.push.apply(
            beam_label_items,
            paper.project.getItems({
                typeQQ: "beam3_label",
            })
        );
        beam_label_items.push.apply(
            beam_label_items,
            paper.project.getItems({
                typeQQ: "beam4_label",
            })
        );

        paper.project.getItems({ sel_type: "downpipe" }).forEach(function (item) {
            paper.project.activeLayer.addChild(item);
        });

        //

        for (let item of beam_label_items) {
            let areaIndex = item.areaIndex;
            item.fillColor = new paper.Color(RoofColour_html_contrasttext_in_areas[areaIndex]);
            if (!item.content_original) item.content_original = item.content;

            if (item.content_original.includes("*")) {
                item.fontWeight = "Italic";
            }

            if (show_engineering) {
                let current_content = item.content_original
                    ? item.content_original.split("(")
                    : item.content
                    ? item.content.split("(")
                    : "";

                let end_desc = item.content_original
                    ? item.content_original.split(")")
                    : item.content
                    ? item.content.split(")")
                    : "";
                if (end_desc.length > 1) end_desc = end_desc[1].trim();
                else end_desc = false;

                if (!current_content || current_content?.[0].length < 2) continue;

                item.content = current_content[0] ? current_content[0].trim() : "";
                // if (item.typeQQ === "beam_label") item.content = current_content[0];
                // if (item.typeQQ === "beam1_label") item.content = BeamType_in_areas[areaIndex];
                // if (item.typeQQ === "beam2_label") item.content = BeamType2_in_areas[areaIndex];
                // if (item.typeQQ === "beam3_label") item.content = BeamType3_in_areas[areaIndex];
                // if (item.typeQQ === "beam4_label") item.content = BeamType4_in_areas[areaIndex];

                // if (window?.app?.designer?.designer2D?.SHOW_BEAM_LENGTHS && item)
                if (current_content.length > 1 && window?.app?.designer?.designer2D?.SHOW_BEAM_LENGTHS)
                    item.content += " (" + current_content[1];
                else if (end_desc) item.content += " " + end_desc;

                if (show_eng) {
                    if (deckMode) {
                        let engineering = window?.job?.QuoteParameters?.ENGINEERING?.Data?.[0];
                        let capacity = engineering?.BearerCapacity;
                        if (item.typeQQ === "beam2_label") capacity = engineering?.JoistCapacity;
                        paper.project.getItems({ nameQQ: item.nameQQ }).forEach(function (_item) {
                            if (_item?.eng_capacity) capacity = _item?.eng_capacity;
                        });
                        item.content += " - " + (capacity * 100).toFixed(1) + "%";
                    } else {
                        item.Engineering = GetEngineeringResult(item.nameQQ);
                        if (item.Engineering && !item.content.includes("%")) {
                            let split = item.Engineering.split("=");
                            let capacity = Number(split[0]) / OVERSTRESS_FACTOR;
                            if (split[1] && (capacity > 0.9 || capacity < 0))
                                item.content += " - " + (capacity * 100).toFixed(1) + "% " + split[1];
                            else if (capacity > 0) item.content += " - " + (capacity * 100).toFixed(1) + "%";

                            if (window.debug && item.content && !item.content.startsWith(item.nameQQ))
                                item.content = item.nameQQ + " - " + item.content;

                            if (split[2]) {
                                item.deflection = split[2];
                            }
                        }
                    }
                }
            }

            paper.project.activeLayer.addChild(item);

            item.shadowColor = RoofColour_html_shadow_in_areas[areaIndex];
            item.shadowBlur = 5;
            item.shadowOffset = new paper.Point(0, 0);
        }

        let post_label_items = paper.project.getItems({
            is_post_label: true,
        });
        post_label_items.push.apply(
            post_label_items,
            paper.project.getItems({
                is_post: true,
            })
        );

        const SHOW_POST_DIMENSIONS = window?.app?.designer?.designer2D?.SHOW_POST_DIMENSIONS;

        paper.project.getItems({ typeQQ: "dimension/post" }).forEach(function (item) {
            item.visible = SHOW_POST_DIMENSIONS;
        });

        let PostCol_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "PostCol", "Classic Cream");

        let PostCol_html_in_areas = [...PostCol_in_areas];
        PostCol_html_in_areas.forEach(function (value, index, array) {
            array[index] = GetHTMLColour(value)[1];
        });

        let post_label_added = [];

        for (let item of post_label_items) {
            let areaIndex = item.areaIndex;
            // let colour = tinycolor([areaIndex]);
            //
            item.fillColor = new paper.Color(RoofColour_html_contrasttext_in_areas[areaIndex]);
            item.shadowColor = new paper.Color(RoofColour_html_shadow_in_areas[areaIndex]);
            // item.shadowColor = colour.isLight()?"black":"white";
            item.shadowBlur = 5;
            item.shadowOffset = new paper.Point(0, 0);

            item.Engineering = GetEngineeringResult(item.nameQQ);

            let engineering_data = item.Engineering;
            if (item.eng_capacity) {
                engineering_data = item.eng_capacity + "=";
            }

            if (engineering_data && show_engineering && show_eng) {
                if (item?.is_post_label && item?.content) {
                    item.content = item.nameQQ;
                }

                if (item.content && item.content.includes("%")) {
                } else if (engineering_data) {
                    let split = engineering_data.split("=");
                    let capacity = Number(split[0]) / OVERSTRESS_FACTOR;

                    if (split[2]) {
                        item.deflection = split[2];
                    }

                    if (item.is_post_label) item.fillColor = new paper.Color("green");
                    if (capacity > 1) {
                        if (item.is_post && item.hasFill() && !item?.content && !item?._content) {
                            if (item.children && item.children.length > 0 && item.children[0]?.content) {
                                item.fillColor = new paper.Color(RoofColour_html_contrasttext_in_areas[areaIndex]);
                                item.shadowColor = new paper.Color(RoofColour_html_shadow_in_areas[areaIndex]);
                                item.shadowBlur = 5;
                                item.shadowOffset = new paper.Point(0, 0);
                            } else {
                                item.fillColor = new paper.Color(PostCol_html_in_areas[areaIndex]);
                            }
                        }

                        if (item.is_post_label) item.content += " - " + (capacity * 100).toFixed(1) + "% " + split[1];
                        if (item.is_post_label) item.fillColor = new paper.Color("#C52f12");
                        if (item.hasStroke()) {
                            item.strokeWidth = 8;
                            item.strokeColor = new paper.Color("#882f12");
                        }
                        if (item.is_post && item.hasFill() && item.nameQQ && item.ref) {
                            var myCircle = new paper.Path.Circle(item.position, 120);
                            myCircle.fillColor = "#C52f1233";
                            myCircle.strokeWidth = 25;
                            myCircle.strokeColor = "#C52f12";
                        }
                    }

                    paper.project.activeLayer.addChild(item);

                    if (deckMode && capacity > 0 && !post_label_added.includes(item.nameQQ)) {
                        let capacity = Number(split[0]);
                        post_label_added.push(item.nameQQ);

                        let offset = 200;
                        if (item.is_post && item.add_post_index !== undefined) {
                            offset = 300;
                        }

                        var pnt = item.position.add(new paper.Point(0, -offset));
                        var text = new paper.PointText(pnt);
                        text.justification = "center";
                        text.fontSize = 70.4;
                        text.content = item.nameQQ + "\n" + (capacity * 100).toFixed(1) + "% ";

                        if (item.is_post && item.add_post_index !== undefined) {
                            text.content = "*ADDED*\n" + text.content;
                        }

                        text.shadowColor = "white";
                        text.shadowBlur = 5;
                        text.shadowOffset = new paper.Point(0, 0);

                        let rect = new paper.Path.Rectangle(
                            pnt.x - text.bounds.width / 2,
                            pnt.y - text.bounds.height / 2,
                            text.bounds.width + 20,
                            text.bounds.height + 20
                        );
                        rect.fillColor = "#eeeeeeCC";
                        rect.strokeWidth = 0;
                        rect.strokeColor = "#eeeeeeCC";
                        text.bringToFront();

                        if (capacity > 1) {
                            rect.position.y += 40;
                            rect.fillColor = "#eeaaaaCC";
                            rect.strokeWidth = 2;
                            rect.strokeColor = "#882f12";
                            text.fillColor = "#882f12";
                            text.fontWeight = "600";
                            // if (item.hasStroke()) {
                            //     item.strokeWidth = 8;
                            //     item.strokeColor = new paper.Color("#882f12");
                            // }
                            // item.fillColor = new paper.Color("#882f12");
                        } else if (capacity > 0.9) {
                            text.fillColor = "#a66b00";
                            text.fontWeight = "600";
                            // item.fillColor = "#a66b00";
                        } else {
                            text.fillColor = "green";
                            text.fontWeight = "400";
                            // item.fillColor = "green";
                        }
                    }
                }
            }
            if (item.is_post_label) {
                paper.project.activeLayer.addChild(item);

                let colour = tinycolor(RoofColour_html_shadow_in_areas[areaIndex]);
                item.shadowColor = colour.isLight() ? "black" : "white";
                item.shadowBlur = 5;
                item.shadowOffset = new paper.Point(0, 0);
                let pnt = item.position;

                let rect = new paper.Path.Rectangle(
                    pnt.x - item.bounds.width / 2 - 10,
                    pnt.y - item.bounds.height / 2 - 30,
                    item.bounds.width + 20,
                    item.bounds.height + 20
                );

                // let rect = new paper.Path.Rectangle(pnt.x, pnt.y, text.bounds.width, text.bounds.height);

                rect.fillColor = "#eeeeeeCC";
                rect.strokeWidth = 0;
                rect.strokeColor = "#eeeeeeCC";
                item.bringToFront();

                // if (capacity > 1) {
                //     rect.position.y += 40;
                //     rect.fillColor = "#eeaaaaCC";
                //     rect.strokeWidth = 2;
                //     rect.strokeColor = "#882f12";
                //     text.fillColor = "#882f12";
                //     text.fontWeight = "600";
                //     if (item.hasStroke()) {
                //         item.strokeWidth = 8;
                //         item.strokeColor = new paper.Color("#882f12");
                //     }
                //     item.fillColor = new paper.Color("#882f12");
                // } else if (capacity > 0.9) {
                //     text.fillColor = "#a66b00";
                //     text.fontWeight = "600";
                //     // text.content = item.nameQQ + " - " + (capacity * 100).toFixed(1) + "% " + split[1];
                //     item.fillColor = "#a66b00";
                // } else {
                //     text.fillColor = "green";
                //     text.fontWeight = "400";
                //     // text.content = item.nameQQ + " - " + (capacity * 100).toFixed(1) + "%";
                //     item.fillColor = "green";
                // }
            }
        }

        // floyver bracket labelling for enginering

        // let deckMode = window?.job?.DesignParameters?.DeckMode;
        if (show_engineering && show_eng) {
            // if (deckMode) {
            //     let posts = paper.project.getItems({
            //         is_post: true,
            //     })

            //     for (let item of posts) {
            //     }
            // }

            let rafter_brackets = paper.project.getItems({
                typeQQ: "riser_bracket",
            });

            let bracket_ordered = [];
            for (let item of rafter_brackets) {
                if ((item.segments && item.segments.length > 2) || item?.bkt_type?.length > 1)
                    bracket_ordered.push(item);
            }
            for (let item of rafter_brackets) {
                if ((item.segments && item.segments.length > 2) || item?.bkt_type?.length > 1) {
                } else {
                    bracket_ordered.push(item);
                }
            }

            let bracket_results_added = [];

            for (let item of bracket_ordered) {
                item.Engineering = GetEngineeringResult(item.nameQQ);
                //
                if (item.Engineering && !bracket_results_added.includes(item.nameQQ)) {
                    bracket_results_added.push(item.nameQQ);
                    let areaIndex = item.areaIndex;
                    let split = item.Engineering.split("=");
                    let capacity = Number(split[0]) / OVERSTRESS_FACTOR;

                    let is_flyover = item.nameQQ.includes("JMB") || item.nameQQ.includes("BK50");

                    if (is_flyover) {
                        let depth = toNumber(GetSpec(item.areaIndex, "SHAPE", "Depth", -1));
                        let length = toNumber(GetSpec(item.areaIndex, "SHAPE", "Length", -1));

                        var pnt = item.position.add(new paper.Point(0, 0));
                        let x_pos = item.position.x - window.paper_origin.x;
                        let y_pos = Math.abs(item.position.y - window.paper_origin.y);
                        if (y_pos > depth - 1000)
                            pnt = pnt.add(new paper.Point(is_flyover ? 0 : 50, is_flyover ? -125 : -250));
                        else if (x_pos < 1000) pnt = pnt.add(new paper.Point(-200, 125));
                        else pnt = pnt.add(new paper.Point(200, 125));
                        var text = new paper.PointText(pnt);
                        text.justification = "center";
                        // if (y_pos > depth - 200 || y_pos < 1000) text.justification = "center";
                        // else if (x_pos < 200) text.justification = "right";
                        // else text.justification = "left";
                        text.fontSize = 90.4;

                        if (capacity > 1.0) {
                            text.content =
                                item.nameQQ +
                                "\n" +
                                (capacity * 100).toFixed(1) +
                                "% " +
                                split[1].replace("Area Load ", "");
                        } else {
                            if (y_pos > depth - 1000) {
                                text.content = (capacity * 100).toFixed(1) + "%";
                                text.fontSize = 80.4;
                            } else {
                                text.content = (capacity * 100).toFixed(1) + "%";
                                text.fontSize = 80.4;
                            }
                        }

                        let colour = tinycolor(RoofColour_html_shadow_in_areas[areaIndex]);
                        text.shadowColor = colour.isLight() ? "black" : "white";
                        text.shadowBlur = 5;
                        text.shadowOffset = new paper.Point(0, 0);

                        let rect = new paper.Path.Rectangle(
                            pnt.x - text.bounds.width / 2 - 10,
                            pnt.y - text.bounds.height / 2 - 30,
                            text.bounds.width + 20,
                            text.bounds.height + 20
                        );

                        // let rect = new paper.Path.Rectangle(pnt.x, pnt.y, text.bounds.width, text.bounds.height);

                        rect.fillColor = "#eeeeeeCC";
                        rect.strokeWidth = 0;
                        rect.strokeColor = "#eeeeeeCC";
                        text.bringToFront();

                        if (capacity > 1) {
                            rect.position.y += 40;
                            rect.fillColor = "#eeaaaaCC";
                            rect.strokeWidth = 2;
                            rect.strokeColor = "#882f12";
                            text.fillColor = "#882f12";
                            text.fontWeight = "600";
                            if (item.hasStroke()) {
                                item.strokeWidth = 8;
                                item.strokeColor = new paper.Color("#882f12");
                            }
                            item.fillColor = new paper.Color("#882f12");
                        } else if (capacity > 0.9) {
                            text.fillColor = "#a66b00";
                            text.fontWeight = "600";
                            // text.content = item.nameQQ + " - " + (capacity * 100).toFixed(1) + "% " + split[1];
                            item.fillColor = "#a66b00";
                        } else {
                            text.fillColor = "green";
                            text.fontWeight = "400";
                            // text.content = item.nameQQ + " - " + (capacity * 100).toFixed(1) + "%";
                            item.fillColor = "green";
                        }
                    }
                }
            }
        }

        const BEAM_AND_POST_MESH_MODE = window.app.designer.designer3D[APP.BEAM_AND_POST_MESH_MODE];

        beam_label_items.forEach(function (item) {
            if (BEAM_AND_POST_MESH_MODE === "Hidden") item.visible = false;
            else item.visible = true;
        });
        post_label_items.forEach(function (item) {
            if (BEAM_AND_POST_MESH_MODE === "Hidden") item.visible = false;
            else item.visible = true;
        });

        beam_items.forEach(function (item) {
            if (BEAM_AND_POST_MESH_MODE === "Hidden") item.visible = false;
            else if (BEAM_AND_POST_MESH_MODE === "Mesh" && !item.strokeColor) item.visible = false;
            else item.visible = true;
        });

        beam_items.forEach(function (item) {
            if (BEAM_AND_POST_MESH_MODE === "Hidden") item.visible = false;
            else if (BEAM_AND_POST_MESH_MODE === "Mesh" && !item.strokeColor) item.visible = false;
            else item.visible = true;
        });

        const FOOTINGS_MESH_MODE = window.app.designer.designer3D[APP.FOOTINGS_MESH_MODE];

        //mesh footings
        paper.project.getItems({ is_footing: true }).forEach(function (item) {
            if (FOOTINGS_MESH_MODE === "Hidden") item.visible = false;
            else item.visible = true;
        });

        paper.project.getItems({ typeQQ: "post" }).forEach(function (item) {
            if (FOOTINGS_MESH_MODE === "Hidden") item.visible = false;
            else item.visible = true;
        });

        //bring text to front
        paper.project.getItems({ class: paper.TextItem }).forEach(function (item) {
            if (item.fixed_size) {
                return;
            }
            paper.project.activeLayer.addChild(item);
            item.bringToFront();
        });

        // deleted posts to top
        paper.project.getItems({ is_post: true, deleted: true }).forEach(function (item) {
            item.bringToFront();
            item.strokeColor = new paper.Color("#444444");
            item.strokeColor.alpha = 0.7;
            item.strokeWidth = 8;
            item.strokeCap = "round";
            item.dashArray = [14, 14];
            item.fillColor = new paper.Color("#BBBBBB88");
            item.fillColor.alpha = 0.15;
        });

        // paper.project.getItems({ is_roofsheet: true }).forEach(function (item, index, array) {
        //     item.fillColor = roofsheet_colour_in_areas_HTML[item.areaIndex];
        //     if (ROOFSHEET__MESH_MODE !== "Render") item.visible = false;
        //     else item.visible = true;
        // });

        // // get roofsheet labels
        // paper.project.getItems({ typeQQ: "sheet_label" }).forEach(function (item) {
        //     item.fontWeight = 600;
        //     if (ROOFSHEET__MESH_MODE === "Hidden") item.visible = false;
        //     else item.visible = true;
        // });
    }
}

export function UpdateDimensions() {
    if (window.svg) {
        let dimension_items = paper.project.getItems({
            is_dimension: true,
        });

        for (let item of dimension_items) {
            if (!item.ref && item.content) {
                item.fillColor = new paper.Color("#888888");
            }
        }
    }
}
// item.is_dimension

export function UpdateAllSVGMaterials() {
    UpdateAttachments();
    UpdateRoofSheets();
    UpdateBeamsAndPosts();
    UpdateDimensions();
    UpdateAllText(window?.app?.designer?.designer2D?.FONT_SIZE);
    UpdateTopElements();

    if (window?.app?.designer?.designer2D?.SELECT_POINT === "ExtendBeam") {
        FormatSVGForExtendBeam();
    }
}

function UpdateAttachments() {
    paper.project.getItems({ is_wall_line: true }).forEach(function (item) {
        item.strokeColor = new paper.Color("#ad623377");
        item.strokeWidth = 20;
        item.strokeCap = "butt";
        item.dashArray = [60, 20];
    });
}

function UpdateTopElements() {
    //WARNING ELEMENTS
    paper.project.getItems({ is_warning_element: true }).forEach(function (item) {
        item.bringToFront();
    });

    //bring ceiling fan point selection to the front
    paper.project.getItems({ is_ceiling_fan_point: true }).forEach(function (item) {
        paper.project.activeLayer.addChild(item);
        item.bringToFront();
        console.log(item);
    });
}

function UpdateJobFromSVG() {
    if (window?.dispatch && window?.job?.DesignParameters?.DeckMode) {
        let engineeringResult = EngineerDeckv2(window.job.AreaSpecifications[0]["BEAMS_AND_POSTS"]);
        window.dispatch({
            type: "UPDATE_ENGINEERING",
            value: engineeringResult,
            areaIndex: 0,
        });
    }
}

export function GetMetaData() {
    let attachments = [];
    paper.project.getItems({ typeQQ: "attachment" }).forEach(function (item) {
        attachments.push({
            ref: item.ref,
            ref2: item.ref2,
            length: item?.lengthQQ !== undefined ? item?.lengthQQ : item?.len,
            area: item?.areaIndex !== undefined ? item?.areaIndex : item?.area,
        });
    });

    let area_data = {};
    paper.project.getItems({ is_beam: true }).forEach(function (item) {
        let area_num = item?.areaIndex !== undefined ? item?.areaIndex : item?.area;
        if (area_num === "undefined") area_num = -1;
        if (!area_data[area_num]) area_data[area_num] = {};
        let num = 0;
        if (area_data?.[area_num]?.num_beam_to_wall_attachments)
            num = area_data?.[area_num]?.num_beam_to_wall_attachments;
        if (item?.E1 === "W") {
            num++;
            area_data[area_num].num_beam_to_wall_attachments = num;
        }
        if (item?.E2 === "W") {
            num++;
            area_data[area_num].num_beam_to_wall_attachments = num;
        }
    });

    window.drawing_svg_meta = {
        attachments: attachments,
        area_data: area_data,
    };
}

export function UpdateAllText(factor) {
    if (window.svg) {
        let last_factor = window.base_font_factor ? window.base_font_factor : 100;
        let change = factor / last_factor;
        paper.project.activeLayer.children.forEach(function (item) {
            if (item.fixed_size) {
                return;
            }
            if (item.fontSize) {
                item.fontSize = item.fontSize * change;
            } else item.content = item.fontSize;
            if (item.children) {
                item.children.forEach(function (item_child) {
                    if (item_child.fontSize) {
                        item_child.fontSize = item_child.fontSize * change;
                        // item.content = replaceContent(item.content);
                    } else item_child.content = item_child.fontSize;
                    if (item_child.content) item_child.content = replaceContent(item_child.content);
                    // item.fontWeight = 600;
                });
            }
            if (item.content) item.content = replaceContent(item.content);
            // item.fontWeight = 600;
        });

        window.base_font_factor = factor;

        paper.project.getItems({ class: paper.TextItem }).forEach(function (item) {
            paper.project.activeLayer.addChild(item);
        });
    }
}

function replaceContent(input) {
    if (!input) return "";
    let output = input;
    if (window.LYSAGHT) {
        output = output.replace("BK34D", "UCE");
        output = output.replace("BK34S", "UCE");
        output = output.replace("BK34", "UCE");
        output = output.replace("BK50", "JMB");
        output = output.replace("BK50", "JMB");
        output = output.replace("BK25", "UCL");
    }
    return output;
}

function UpdateItemsInDrawing(
    name_string_to_match,
    secondard_parameter_to_match = null,
    section,
    parameter,
    default_value = ""
) {
    if (window.svg) {
        let values_in_areas = GetSpecAllAreas(section, parameter, default_value);

        if (parameter === "RoofSheetColour")
            values_in_areas.forEach(function (value, index, array) {
                array[index] = GetHTMLColour(value)[1];
            });

        for (let key in window.svg.children) {
            if (key.startsWith(name_string_to_match)) {
                let item = window.svg.children[key];

                let areaIndex = item.areaIndex ? item.areaIndex : 0;
                item.fillColor = new paper.Color(values_in_areas[areaIndex]);
                // item.fillColor.alpha = 1;
                // new_item.children[key].onMouseEnter = function (event) {
                //         // document.querySelector(".QQ2DCanvas-qq2dCanvasContainer-578").style.cursor = "pointer";
                //
                //     }
            }
        }
    }
}

export function GetSpec(areaIndex, Section, Parameter, default_value) {
    if (!window.job) return default_value;
    if (window.job) {
        if (
            window.job.AreaSpecifications &&
            window.job.AreaSpecifications[areaIndex] &&
            window.job.AreaSpecifications[areaIndex][Section] &&
            window.job.AreaSpecifications[areaIndex][Section][Parameter]
        ) {
            return window.job.AreaSpecifications[areaIndex][Section][Parameter];
        }
    }
    return default_value;
}

export function GetSpecAllAreasAlpha(Section, Parameter, default_value) {
    let alpha_in_areas = GetSpecAllAreas(Section, Parameter, default_value);
    alpha_in_areas.forEach(function (value, index, array) {
        array[index] = COMMON.GetColourAlpha(value);
    });
    return alpha_in_areas;
}
export function GetSpecAllAreasColourHTML(Section, Parameter, default_value, underside = false) {
    let colour_in_areas = GetSpecAllAreas(Section, Parameter, default_value);
    colour_in_areas.forEach(function (value, index, array) {
        array[index] = GetHTMLColour(value)[underside ? 1 : 0];
    });
    return colour_in_areas;
}

function GetEngineeringResult(BeamorPostName) {
    if (!BeamorPostName) return null;

    let EngineeringResults = COMMON.get(window.job, "QuoteParameters.ENGINEERING.EngineeringResults");
    let engineeringHashCode = COMMON.get(window.job, "QuoteParameters.ENGINEERING.engineeringHashCode");
    if (!EngineeringResults) return null;
    if (!engineeringHashCode) return null;

    if (EngineeringResults.BeamResults) {
        let max_result = 0;
        let max_result_match = null;
        for (var beam_names in EngineeringResults.BeamResults) {
            if (beam_names.startsWith(BeamorPostName + ",") || beam_names.includes("," + BeamorPostName + ","))
                return EngineeringResults.BeamResults[beam_names];

            let beam_split = beam_names.split(",");
            for (let beam_section of beam_split) {
                if (beam_section && beam_section.trim() != "") {
                    let beam_section_stripped = beam_section.replace(/[^A-Z0-9]/g, "");
                    if (beam_section_stripped === BeamorPostName) {
                        let split = EngineeringResults.BeamResults[beam_names].split("=");
                        let capacity = Number(split[0]);
                        if (capacity > max_result) {
                            max_result = capacity;
                            max_result_match = EngineeringResults.BeamResults[beam_names];
                        }
                    }
                }
            }
        }
        if (max_result_match != null) {
            return max_result_match;
        }
    }
    if (EngineeringResults.ColumnResults) {
        for (var col_name in EngineeringResults.ColumnResults) {
            if (col_name === BeamorPostName) return EngineeringResults.ColumnResults[col_name];
        }
    }

    if (EngineeringResults.AttachmentBracketResults) {
        for (var bracket_name in EngineeringResults.AttachmentBracketResults) {
            if (window.LYSAGHT) {
                let name = bracket_name.replace("BK50", "JMB");
                name = name.replace("BK34D", "UCE");
                name = name.replace("BK34S", "UCE");
                name = name.replace("BK34", "UCE");
                if (name === BeamorPostName || bracket_name === BeamorPostName)
                    return EngineeringResults.AttachmentBracketResults[bracket_name];
            } else if (bracket_name === BeamorPostName)
                return EngineeringResults.AttachmentBracketResults[bracket_name];
        }
    }
    return null;
}

function GetAttachmentBracketEngineeringResult(BeamName) {
    if (!BeamName) return null;
    //
    //
    let EngineeringResults = COMMON.get(window.job, "QuoteParameters.ENGINEERING.EngineeringResults");
    let engineeringHashCode = COMMON.get(window.job, "QuoteParameters.ENGINEERING.engineeringHashCode");
    if (!EngineeringResults) return null;
    if (!engineeringHashCode) return null;

    if (EngineeringResults.BeamAttachmentBracketResults) {
        for (var beam_names in EngineeringResults.BeamAttachmentBracketResults) {
            if (
                beam_names === BeamName ||
                beam_names.startsWith(BeamName + ",") ||
                beam_names.includes("," + BeamName + ",")
            )
                return EngineeringResults.BeamAttachmentBracketResults[beam_names];
        }
    }
    return null;
}

export function getToolSetForPopItem(popItem) {
    if (!popItem) return null;

    const {
        is_beam,
        is_post,
        is_footing,
        is_roofsheet,
        is_attachment,
        is_attachment_ghost,
        is_attachment_roof,
        is_gutter,
        is_downpipe,
    } = popItem;

    if (is_beam || is_post || is_footing) {
        return APP.BEAMS_AND_POSTS_TOOL;
    }
    if (is_roofsheet) {
        return APP.ROOFSHEET_TOOL;
    }
    if (is_attachment || is_attachment_ghost || is_attachment_roof) {
        return APP.ATTACHMENT_TOOL;
    }
    if (is_gutter || is_downpipe) {
        return APP.GUTTERS_DOWNPIPES_TOOL;
    }

    return null;
}
